export const color = {
  "avatar": {
    "neutral": {
      "light": "#ffffff",
      "dark": "#000000"
    },
    "gray": {
      "light": "#dddad4",
      "dark": "#333332"
    },
    "blue": {
      "light": "#aad8f9",
      "dark": "#003e6c"
    },
    "green": {
      "light": "#a4e6bd",
      "dark": "#004b1c"
    },
    "yellow": {
      "light": "#fff1c2",
      "dark": "#685106"
    },
    "orange": {
      "light": "#ffcaaa",
      "dark": "#732706"
    },
    "pink": {
      "light": "#ffc0e2",
      "dark": "#681d45"
    },
    "purple": {
      "light": "#d9c1f7",
      "dark": "#381c5c"
    },
    "iris": {
      "light": "#b8c5ff",
      "dark": "#1f216a"
    },
    "red": {
      "light": "#fabbc3",
      "dark": "#860011"
    }
  },
  "background": {
    "lowcontrast": {
      "onlightprimary": "rgba(170, 168, 163, .12)",
      "onlightsecondary": "rgba(170, 168, 163, .12)",
      "onlightbrandneutral": "rgba(170, 168, 163, .12)",
      "ondarkprimary": "rgba(221, 218, 212, .13)",
      "ondarksecondary": "rgba(221, 218, 212, .13)",
      "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
    }
  },
  "dataviz": {
    "blue": {
      "200": "#aad8f9",
      "400": "#5ab3f3",
      "600": "#0089ec",
      "800": "#006fc0",
      "1000": "#003e6c"
    },
    "green": {
      "200": "#a4e6bd",
      "400": "#59d186",
      "600": "#00b845",
      "800": "#008331",
      "1000": "#004b1c"
    },
    "yellow": {
      "200": "#fff1c2",
      "400": "#ffe797",
      "600": "#ffcd27",
      "800": "#b88f0b",
      "1000": "#685106"
    },
    "orange": {
      "200": "#ffcaaa",
      "400": "#ffa46d",
      "600": "#ff8027",
      "800": "#b95319",
      "1000": "#732706"
    },
    "pink": {
      "200": "#ffc0e2",
      "400": "#fe86c7",
      "600": "#fe46aa",
      "800": "#bb337d",
      "1000": "#681d45"
    },
    "purple": {
      "200": "#d9c1f7",
      "400": "#b689f0",
      "600": "#8e48e8",
      "800": "#6b36ae",
      "1000": "#381c5c"
    }
  },
  "element": {
    "primary": {
      "onlightprimary": "#000000",
      "ondarkprimary": "#ffffff",
      "onlightsecondary": "#000000",
      "ondarksecondary": "#ffffff",
      "onlightbrandneutral": "#000000",
      "ondarkbrandhighlight": "#ffffff"
    },
    "secondary": {
      "onlightprimary": "#716f6d",
      "ondarkprimary": "#aaa8a3",
      "onlightsecondary": "#716f6d",
      "ondarksecondary": "#aaa8a3",
      "onlightbrandneutral": "#716f6d",
      "ondarkbrandhighlight": "#ffffff"
    },
    "lowcontrast": {
      "onlightprimary": "rgba(170, 168, 163, 0.40)",
      "ondarkprimary": "rgba(221, 218, 212, 0.23)",
      "onlightsecondary": "rgba(170, 168, 163, 0.40)",
      "ondarksecondary": "rgba(221, 218, 212, 0.23)",
      "onlightbrandneutral": "rgba(170, 168, 163, 0.40)",
      "ondarkbrandhighlight": "#ff281e"
    },
    "brandhighlight": {
      "onlightprimary": "#e10014",
      "ondarkprimary": "#e10014",
      "onlightsecondary": "#e10014",
      "ondarksecondary": "#e10014",
      "onlightbrandneutral": "#e10014",
      "ondarkbrandhighlight": "#f8ff3c"
    },
    "savings": {
      "onlightprimary": "#008331",
      "ondarkprimary": "#00b845",
      "onlightsecondary": "#008331",
      "ondarksecondary": "#00b845",
      "onlightbrandneutral": "#00722b",
      "ondarkbrandhighlight": "#ffffff"
    }
  },
  "feedback": {
    "background": {
      "information": {
        "tonal": {
          "onlightprimary": "#aad8f9",
          "onlightsecondary": "#aad8f9",
          "onlightbrandneutral": "#aad8f9",
          "ondarkprimary": "#003e6c",
          "ondarksecondary": "#003e6c",
          "ondarkbrandhighlight": "#aad8f9"
        }
      },
      "success": {
        "tonal": {
          "onlightprimary": "#a4e6bd",
          "onlightsecondary": "#a4e6bd",
          "onlightbrandneutral": "#a4e6bd",
          "ondarkprimary": "#004b1c",
          "ondarksecondary": "#004b1c",
          "ondarkbrandhighlight": "#a4e6bd"
        }
      },
      "warning": {
        "tonal": {
          "onlightprimary": "#ffe797",
          "onlightsecondary": "#ffe797",
          "onlightbrandneutral": "#ffe797",
          "ondarkprimary": "#685106",
          "ondarksecondary": "#685106",
          "ondarkbrandhighlight": "#ffe797"
        }
      },
      "error": {
        "tonal": {
          "onlightprimary": "#ffcaaa",
          "onlightsecondary": "#ffcaaa",
          "onlightbrandneutral": "#ffcaaa",
          "ondarkprimary": "#732706",
          "ondarksecondary": "#732706",
          "ondarkbrandhighlight": "#ffcaaa"
        }
      }
    },
    "element": {
      "information": {
        "onlightprimary": "#006fc0",
        "onlightsecondary": "#006fc0",
        "onlightbrandneutral": "#006fc0",
        "ondarkprimary": "#0089ec",
        "ondarksecondary": "#0089ec",
        "ondarkbrandhighlight": "#ffffff",
        "tonal": {
          "onlightprimary": "#003e6c",
          "onlightsecondary": "#003e6c",
          "onlightbrandneutral": "#003e6c",
          "ondarkprimary": "#aad8f9",
          "ondarksecondary": "#aad8f9",
          "ondarkbrandhighlight": "#003e6c"
        }
      },
      "success": {
        "onlightprimary": "#008331",
        "onlightsecondary": "#008331",
        "onlightbrandneutral": "#00722b",
        "ondarkprimary": "#00b845",
        "ondarksecondary": "#00b845",
        "ondarkbrandhighlight": "#ffffff",
        "tonal": {
          "onlightprimary": "#004b1c",
          "onlightsecondary": "#004b1c",
          "onlightbrandneutral": "#004b1c",
          "ondarkprimary": "#a4e6bd",
          "ondarksecondary": "#a4e6bd",
          "ondarkbrandhighlight": "#004b1c"
        }
      },
      "warning": {
        "onlightprimary": "#ffcd27",
        "onlightsecondary": "#ffcd27",
        "onlightbrandneutral": "#ffcd27",
        "ondarkprimary": "#ffcd27",
        "ondarksecondary": "#ffcd27",
        "ondarkbrandhighlight": "#ffffff",
        "tonal": {
          "onlightprimary": "#685106",
          "onlightsecondary": "#685106",
          "onlightbrandneutral": "#685106",
          "ondarkprimary": "#fff1c2",
          "ondarksecondary": "#fff1c2",
          "ondarkbrandhighlight": "#685106"
        }
      },
      "error": {
        "onlightprimary": "#b95319",
        "onlightsecondary": "#b95319",
        "onlightbrandneutral": "#a74815",
        "ondarkprimary": "#ff8027",
        "ondarksecondary": "#ff8027",
        "ondarkbrandhighlight": "#ffffff",
        "tonal": {
          "onlightprimary": "#732706",
          "onlightsecondary": "#732706",
          "onlightbrandneutral": "#732706",
          "ondarkprimary": "#ffcaaa",
          "ondarksecondary": "#ffcaaa",
          "ondarkbrandhighlight": "#732706"
        }
      }
    }
  },
  "black": "#000000",
  "white": "#ffffff",
  "standardred": "#e10014",
  "coral": "#ff281e",
  "neonyellow": "#f8ff3c",
  "stone": "#f8f3e9",
  "gray": {
    "100": "#f8f7f5",
    "200": "#dddad4",
    "400": "#aaa8a3",
    "600": "#716f6d",
    "900": "#333332",
    "1100": "#1d1c1c"
  },
  "orange": {
    "200": "#ffcaaa",
    "400": "#ffa46d",
    "600": "#ff8027",
    "800": "#b95319",
    "900": "#a74815",
    "1000": "#732706"
  },
  "yellow": {
    "200": "#fff1c2",
    "400": "#ffe797",
    "600": "#ffcd27",
    "800": "#b88f0b",
    "900": "#a27e0a",
    "1000": "#685106"
  },
  "blue": {
    "200": "#aad8f9",
    "400": "#5ab3f3",
    "600": "#0089ec",
    "800": "#006fc0",
    "900": "#005b9e",
    "1000": "#003e6c"
  },
  "green": {
    "200": "#a4e6bd",
    "400": "#59d186",
    "600": "#00b845",
    "800": "#008331",
    "900": "#00722b",
    "1000": "#004b1c"
  },
  "pink": {
    "200": "#ffc0e2",
    "400": "#fe86c7",
    "600": "#fe46aa",
    "800": "#bb337d",
    "900": "#9d2b69",
    "1000": "#681d45"
  },
  "purple": {
    "200": "#d9c1f7",
    "400": "#b689f0",
    "600": "#8e48e8",
    "800": "#6b36ae",
    "900": "#572c8e",
    "1000": "#381c5c"
  },
  "iris": {
    "200": "#b8c5ff",
    "400": "#8496fa",
    "600": "#5055f0",
    "800": "#3e42be",
    "900": "#31359d",
    "1000": "#1f216a"
  },
  "limitedred": {
    "200": "#fabbc3",
    "1000": "#860011",
    "default": "#ee001e"
  },
  "surface": {
    "lightprimary": "#ffffff",
    "lightsecondary": "#f8f7f5",
    "lightbrandneutral": "#f8f3e9",
    "darkprimary": "#000000",
    "darksecondary": "#1d1c1c",
    "darkbrandhighlight": "#e10014"
  }
}
export const badgeindicator = {
  "small": {
    "text": {
      "lineheight": "0.75rem"
    }
  },
  "medium": {
    "text": {
      "lineheight": "0.875rem"
    }
  },
  "large": {
    "text": {
      "lineheight": "1rem"
    }
  },
  "xlarge": {
    "text": {
      "lineheight": "1.25rem"
    }
  },
  "2xlarge": {
    "text": {
      "lineheight": "1.5rem"
    }
  }
}
export const badges = {
  "border": {
    "color": {
      "onlightprimary": "#ffffff",
      "onlightsecondary": "#f8f7f5",
      "onlightbrandneutral": "#f8f3e9",
      "ondarkprimary": "#000000",
      "ondarksecondary": "#1d1c1c",
      "ondarkbrandhighlight": "#e10014"
    }
  },
  "text": {
    "color": {
      "onred": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      },
      "onyellow": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "ongreen": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "onorange": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "onblue": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "onneonyellow": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "onstone": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "ongrayhighcontrast": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "ongraylowcontrast": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      },
      "onwhite": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      },
      "onblack": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    }
  },
  "background": {
    "color": {
      "red": {
        "onlightprimary": "#e10014",
        "onlightsecondary": "#e10014",
        "onlightbrandneutral": "#e10014",
        "ondarkprimary": "#e10014",
        "ondarksecondary": "#e10014",
        "ondarkbrandhighlight": "#e10014"
      },
      "yellow": {
        "onlightprimary": "#ffcd27",
        "onlightsecondary": "#ffcd27",
        "onlightbrandneutral": "#ffcd27",
        "ondarkprimary": "#ffcd27",
        "ondarksecondary": "#ffcd27",
        "ondarkbrandhighlight": "#ffcd27"
      },
      "green": {
        "onlightprimary": "#008331",
        "onlightsecondary": "#008331",
        "onlightbrandneutral": "#00722b",
        "ondarkprimary": "#00b845",
        "ondarksecondary": "#00b845",
        "ondarkbrandhighlight": "#00b845"
      },
      "orange": {
        "onlightprimary": "#b95319",
        "onlightsecondary": "#b95319",
        "onlightbrandneutral": "#a74815",
        "ondarkprimary": "#ff8027",
        "ondarksecondary": "#ff8027",
        "ondarkbrandhighlight": "#ff8027"
      },
      "blue": {
        "onlightprimary": "#006fc0",
        "onlightsecondary": "#006fc0",
        "onlightbrandneutral": "#006fc0",
        "ondarkprimary": "#0089ec",
        "ondarksecondary": "#0089ec",
        "ondarkbrandhighlight": "#0089ec"
      },
      "neonyellow": {
        "onlightprimary": "#f8ff3c",
        "onlightsecondary": "#f8ff3c",
        "onlightbrandneutral": "#f8ff3c",
        "ondarkprimary": "#f8ff3c",
        "ondarksecondary": "#f8ff3c",
        "ondarkbrandhighlight": "#f8ff3c"
      },
      "stone": {
        "onlightprimary": "#f8f3e9",
        "onlightsecondary": "#f8f3e9",
        "onlightbrandneutral": "#f8f3e9",
        "ondarkprimary": "#f8f3e9",
        "ondarksecondary": "#f8f3e9",
        "ondarkbrandhighlight": "#f8f3e9"
      },
      "grayhighcontrast": {
        "onlightprimary": "#716f6d",
        "onlightsecondary": "#716f6d",
        "onlightbrandneutral": "#716f6d",
        "ondarkprimary": "#aaa8a3",
        "ondarksecondary": "#aaa8a3",
        "ondarkbrandhighlight": "#aaa8a3"
      },
      "graylowcontrast": {
        "onlightprimary": "#dddad4",
        "onlightsecondary": "#dddad4",
        "onlightbrandneutral": "#dddad4",
        "ondarkprimary": "#333332",
        "ondarksecondary": "#333332",
        "ondarkbrandhighlight": "#333332"
      },
      "white": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      },
      "black": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      }
    }
  }
}
export const button = {
  "primary": {
    "background": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    },
    "label": {
      "color": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      }
    },
    "border": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    }
  },
  "secondary": {
    "background": {
      "color": {
        "onlightprimary": "transparent",
        "onlightsecondary": "transparent",
        "onlightbrandneutral": "transparent",
        "ondarkprimary": "transparent",
        "ondarksecondary": "transparent",
        "ondarkbrandhighlight": "transparent"
      }
    },
    "label": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    },
    "border": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    }
  }
}
export const buttonicon = {
  "ghost": {
    "background": {
      "color": {
        "hover": {
          "onlightprimary": "rgba(170, 168, 163, .12)",
          "onlightsecondary": "rgba(170, 168, 163, .12)",
          "onlightbrandneutral": "rgba(170, 168, 163, .12)",
          "ondarkprimary": "rgba(221, 218, 212, .13)",
          "ondarksecondary": "rgba(221, 218, 212, .13)",
          "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
        },
        "onlightprimary": "transparent",
        "onlightsecondary": "transparent",
        "onlightbrandneutral": "transparent",
        "ondarkprimary": "transparent",
        "ondarksecondary": "transparent",
        "ondarkbrandhighlight": "transparent"
      }
    },
    "border": {
      "color": {
        "hover": {
          "onlightprimary": "rgba(170, 168, 163, .12)",
          "onlightsecondary": "rgba(170, 168, 163, .12)",
          "onlightbrandneutral": "rgba(170, 168, 163, .12)",
          "ondarkprimary": "rgba(221, 218, 212, .13)",
          "ondarksecondary": "rgba(221, 218, 212, .13)",
          "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
        }
      }
    },
    "focusring": {
      "color": {
        "inside": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffffff"
        }
      }
    }
  },
  "lowcontrasttonal": {
    "background": {
      "color": {
        "floating": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#333332",
          "ondarksecondary": "#333332",
          "ondarkbrandhighlight": "#333332"
        },
        "onlightprimary": "rgba(170, 168, 163, .12)",
        "onlightsecondary": "rgba(170, 168, 163, .12)",
        "onlightbrandneutral": "rgba(170, 168, 163, .12)",
        "ondarkprimary": "rgba(221, 218, 212, .13)",
        "ondarksecondary": "rgba(221, 218, 212, .13)",
        "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
      }
    },
    "border": {
      "color": {
        "onlightprimary": "rgba(170, 168, 163, .12)",
        "onlightsecondary": "rgba(170, 168, 163, .12)",
        "onlightbrandneutral": "rgba(170, 168, 163, .12)",
        "ondarkprimary": "rgba(221, 168, 163, .13)",
        "ondarksecondary": "rgba(221, 218, 212, .13)",
        "ondarkbrandhighlight": "rgba(0, 0, 0, .05)",
        "floating": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#333332",
          "ondarksecondary": "#333332",
          "ondarkbrandhighlight": "#333332"
        }
      }
    },
    "focusring": {
      "color": {
        "inside": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffffff"
        }
      }
    }
  },
  "lowcontrastsolid": {
    "background": {
      "color": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000",
        "floating": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#333332",
          "ondarksecondary": "#333332",
          "ondarkbrandhighlight": "#333332"
        }
      }
    },
    "border": {
      "color": {
        "visible": {
          "onlightprimary": "#dddad4",
          "onlightsecondary": "#dddad4",
          "onlightbrandneutral": "#dddad4",
          "ondarkprimary": "#333332",
          "ondarksecondary": "#333332",
          "ondarkbrandhighlight": "#333332"
        },
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000",
        "floating": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#333332",
          "ondarksecondary": "#333332",
          "ondarkbrandhighlight": "#333332"
        }
      }
    },
    "focusring": {
      "color": {
        "inside": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffffff"
        }
      }
    }
  },
  "highcontrast": {
    "icon": {
      "color": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      }
    },
    "background": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff",
        "floating": {
          "onlightprimary": "#333332",
          "onlightsecondary": "#333332",
          "onlightbrandneutral": "#333332",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffffff"
        }
      }
    },
    "border": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff",
        "floating": {
          "onlightprimary": "#333332",
          "onlightsecondary": "#333332",
          "onlightbrandneutral": "#333332",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffffff"
        }
      }
    },
    "focusring": {
      "color": {
        "inside": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#000000",
          "ondarksecondary": "#000000",
          "ondarkbrandhighlight": "#000000"
        }
      }
    }
  }
}
export const calendar = {
  "date": {
    "background": {
      "color": {
        "selected": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "highlight": {
            "onlightprimary": "#e10014",
            "onlightsecondary": "#e10014",
            "onlightbrandneutral": "#e10014",
            "ondarkprimary": "#ffffff",
            "ondarksecondary": "#ffffff"
          }
        },
        "hover": {
          "onlightprimary": "rgba(170, 168, 163, .12)",
          "onlightsecondary": "rgba(170, 168, 163, .12)",
          "onlightbrandneutral": "rgba(170, 168, 163, .12)",
          "ondarkprimary": "rgba(221, 218, 212, .13)",
          "ondarksecondary": "rgba(221, 218, 212, .13)"
        }
      }
    },
    "label": {
      "color": {
        "selected": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#000000",
          "ondarksecondary": "#000000",
          "highlight": {
            "onlightprimary": "#ffffff",
            "onlightsecondary": "#ffffff",
            "onlightbrandneutral": "#ffffff",
            "ondarkprimary": "#000000",
            "ondarksecondary": "#000000"
          }
        }
      }
    },
    "indicator": {
      "color": {
        "selected": {
          "onlightprimary": "#ffffff",
          "onlightsecondary": "#ffffff",
          "onlightbrandneutral": "#ffffff",
          "ondarkprimary": "#000000",
          "ondarksecondary": "#000000"
        },
        "highlight": {
          "onlightprimary": "#e10014",
          "onlightsecondary": "#e10014",
          "onlightbrandneutral": "#e10014"
        }
      }
    }
  }
}
export const carouselscrollbar = {
  "trackoverlay": {
    "color": {
      "onlightprimary": "rgba(0, 0, 0, 0.15)",
      "onlightsecondary": "rgba(0, 0, 0, 0.15)",
      "onlightbrandneutral": "rgba(0, 0, 0, 0.15)",
      "ondarkprimary": "rgba(255, 255, 255, 0.15)",
      "ondarksecondary": "rgba(255, 255, 255, 0.15)",
      "ondarkbrandhighlight": "rgba(255, 255, 255, 0.20)"
    }
  },
  "thumb": {
    "color": {
      "onlightprimary": "#716f6d",
      "onlightsecondary": "#716f6d",
      "onlightbrandneutral": "#716f6d",
      "ondarkprimary": "#aaa8a3",
      "ondarksecondary": "#aaa8a3",
      "ondarkbrandhighlight": "#ffffff"
    }
  },
  "track": {
    "color": {
      "onlightprimary": "#aaa8a3",
      "onlightsecondary": "#aaa8a3",
      "onlightbrandneutral": "#aaa8a3",
      "ondarkprimary": "#dddad4",
      "ondarksecondary": "#dddad4",
      "ondarkbrandhighlight": "#ff281e"
    }
  }
}
export const checkbox = {
  "icon": {
    "color": {
      "selected": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#000000"
      }
    }
  },
  "background": {
    "color": {
      "selected": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#ffffff"
      }
    }
  }
}
export const forms = {
  "border": {
    "color": {
      "error": {
        "tonal": {
          "onlightprimary": "#732706",
          "onlightsecondary": "#732706",
          "onlightbrandneutral": "#732706",
          "ondarkprimary": "#ffcaaa",
          "ondarksecondary": "#ffcaaa",
          "ondarkbrandhighlight": "#ffcaaa"
        },
        "focus": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#ffcaaa"
        }
      },
      "success": {
        "tonal": {
          "onlightprimary": "#004b1c",
          "onlightsecondary": "#004b1c",
          "onlightbrandneutral": "#004b1c",
          "ondarkprimary": "#a4e6bd",
          "ondarksecondary": "#a4e6bd",
          "ondarkbrandhighlight": "#a4e6bd"
        },
        "focus": {
          "onlightprimary": "#000000",
          "onlightsecondary": "#000000",
          "onlightbrandneutral": "#000000",
          "ondarkprimary": "#ffffff",
          "ondarksecondary": "#ffffff",
          "ondarkbrandhighlight": "#a4e6bd"
        }
      }
    }
  },
  "element": {
    "color": {
      "onerror": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#000000"
      },
      "onsuccess": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#000000"
      }
    }
  },
  "container": {
    "background": {
      "filled": {
        "readonly": {
          "onlightprimary": "transparent",
          "onlightsecondary": "transparent",
          "onlightbrandneutral": "transparent",
          "ondarkprimary": "#dddad4",
          "ondarksecondary": "#dddad4",
          "ondarkbrandhighlight": "#000000"
        }
      }
    }
  },
  "highlight": {
    "color": {
      "overflow": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#000000"
      }
    }
  },
  "text": {
    "color": {
      "overflow": {
        "onlightprimary": "#ffffff",
        "onlightsecondary": "#ffffff",
        "onlightbrandneutral": "#ffffff",
        "ondarkprimary": "#000000",
        "ondarksecondary": "#000000",
        "ondarkbrandhighlight": "#ffffff"
      }
    }
  }
}
export const knobs = {
  "shadow": "0px 1px 10px 0px rgba(0, 0, 0, 0.24), 0px 2px 4px 0px rgba(0, 0, 0, 0.32)"
}
export const loader = {
  "overlay": {
    "background": {
      "color": {
        "onlightprimary": "rgba(255, 255, 255, 0.9)",
        "onlightsecondary": "rgba(248, 247, 245, 0.9)",
        "onlightbrandneutral": "rgba(248, 243, 233, 0.9)",
        "ondarkprimary": "rgba(0, 0, 0, 0.8)",
        "ondarksecondary": "rgba(29, 28, 28, 0.8)",
        "ondarkbrandhighlight": "#e10014"
      }
    }
  }
}
export const modal = {
  "closebutton": {
    "background": {
      "color": {
        "unscrolled": {
          "onlightprimary": "#ffffff",
          "ondarksecondary": "#1d1c1c"
        },
        "scrolled": {
          "onlightprimary": "#ffffff",
          "ondarksecondary": "#333332"
        }
      }
    }
  },
  "overlay": {
    "color": {
      "light": "rgba(0, 0, 0, .80)",
      "dark": "rgba(0, 0, 0, .80)"
    }
  }
}
export const notification = {
  "information": {
    "button": {
      "label": {
        "color": {
          "primary": {
            "onlightprimary": "#aad8f9",
            "onlightsecondary": "#aad8f9",
            "onlightbrandneutral": "#aad8f9",
            "ondarkprimary": "#003e6c",
            "ondarksecondary": "#003e6c",
            "ondarkbrandhighlight": "#aad8f9"
          }
        }
      },
      "background": {
        "color": {
          "primary": {
            "onlightprimary": "#003e6c",
            "onlightsecondary": "#003e6c",
            "onlightbrandneutral": "#003e6c",
            "ondarkprimary": "#aad8f9",
            "ondarksecondary": "#aad8f9",
            "ondarkbrandhighlight": "#003e6c"
          }
        }
      }
    }
  },
  "success": {
    "button": {
      "label": {
        "color": {
          "primary": {
            "onlightprimary": "#a4e6bd",
            "onlightsecondary": "#a4e6bd",
            "onlightbrandneutral": "#a4e6bd",
            "ondarkprimary": "#004b1c",
            "ondarksecondary": "#004b1c",
            "ondarkbrandhighlight": "#a4e6bd"
          }
        }
      },
      "background": {
        "color": {
          "primary": {
            "onlightprimary": "#004b1c",
            "onlightsecondary": "#004b1c",
            "onlightbrandneutral": "#004b1c",
            "ondarkprimary": "#a4e6bd",
            "ondarksecondary": "#a4e6bd",
            "ondarkbrandhighlight": "#004b1c"
          }
        }
      }
    }
  },
  "warning": {
    "button": {
      "label": {
        "color": {
          "primary": {
            "onlightprimary": "#ffe797",
            "onlightsecondary": "#ffe797",
            "onlightbrandneutral": "#ffe797",
            "ondarkprimary": "#685106",
            "ondarksecondary": "#685106",
            "ondarkbrandhighlight": "#ffe797"
          }
        }
      },
      "background": {
        "color": {
          "primary": {
            "onlightprimary": "#685106",
            "onlightsecondary": "#685106",
            "onlightbrandneutral": "#685106",
            "ondarkprimary": "#fff1c2",
            "ondarksecondary": "#fff1c2",
            "ondarkbrandhighlight": "#685106"
          }
        }
      }
    }
  },
  "error": {
    "button": {
      "label": {
        "color": {
          "primary": {
            "onlightprimary": "#ffcaaa",
            "onlightsecondary": "#ffcaaa",
            "onlightbrandneutral": "#ffcaaa",
            "ondarkprimary": "#732706",
            "ondarksecondary": "#732706",
            "ondarkbrandhighlight": "#ffcaaa"
          }
        }
      },
      "background": {
        "color": {
          "primary": {
            "onlightprimary": "#732706",
            "onlightsecondary": "#732706",
            "onlightbrandneutral": "#732706",
            "ondarkprimary": "#ffcaaa",
            "ondarksecondary": "#ffcaaa",
            "ondarkbrandhighlight": "#732706"
          }
        }
      }
    }
  },
  "interactive": {
    "focusring": {
      "color": {
        "onlightprimary": "#000000",
        "onlightsecondary": "#000000",
        "onlightbrandneutral": "#000000",
        "ondarkprimary": "#ffffff",
        "ondarksecondary": "#ffffff",
        "ondarkbrandhighlight": "#000000"
      }
    }
  }
}
export const pagination = {
  "pageitem": {
    "background": {
      "color": {
        "hover": {
          "onlightprimary": "rgba(170, 168, 163, .12)",
          "onlightsecondary": "rgba(170, 168, 163, .12)",
          "onlightbrandneutral": "rgba(170, 168, 163, .12)",
          "ondarkprimary": "rgba(221, 218, 212, .13)",
          "ondarksecondary": "rgba(221, 218, 212, .13)",
          "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
        }
      }
    }
  }
}
export const scrollable = {
  "thumb": {
    "color": {
      "hover": {
        "onlightprimary": "rgba(0, 0, 0, .65)",
        "onlightsecondary": "rgba(0, 0, 0, .65)",
        "onlightbrandneutral": "rgba(0, 0, 0, .65)",
        "ondarkprimary": "rgba(255, 255, 255, .65)",
        "ondarksecondary": "rgba(255, 255, 255, .65)",
        "ondarkbrandhighlight": "rgba(255, 255, 255, 1)"
      },
      "onlightprimary": "rgba(0, 0, 0, .44)",
      "onlightsecondary": "rgba(0, 0, 0, .44)",
      "onlightbrandneutral": "rgba(0, 0, 0, .44)",
      "ondarkprimary": "rgba(255, 255, 255, .44)",
      "ondarksecondary": "rgba(255, 255, 255, .44)",
      "ondarkbrandhighlight": "rgba(255, 255, 255, .80)"
    },
    "border": {
      "color": {
        "onlightprimary": "rgba(255, 255, 255, .65)",
        "onlightsecondary": "rgba(248, 247, 245, .85)",
        "onlightbrandneutral": "rgba(248, 243, 233, .85)",
        "ondarkprimary": "rgba(0, 0, 0, .65)",
        "ondarksecondary": "rgba(29, 28, 28, .65)",
        "ondarkbrandhighlight": "rgba(255, 0, 20, 1)"
      }
    }
  }
}
export const table = {
  "background": {
    "color": {
      "striped": {
        "onlightprimary": "rgba(170, 168, 163, .12)",
        "onlightsecondary": "rgba(170, 168, 163, .12)",
        "onlightbrandneutral": "rgba(170, 168, 163, .12)",
        "ondarkprimary": "rgba(221, 218, 212, .13)",
        "ondarksecondary": "rgba(221, 218, 212, .13)",
        "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
      }
    }
  }
}
export const tabs = {
  "label": {
    "color": {
      "highlight": {
        "selected": {
          "onlightprimary": "#e10014",
          "onlightsecondary": "#e10014",
          "onlightbrandneutral": "#e10014"
        }
      }
    }
  },
  "indicator": {
    "color": {
      "highlight": {
        "selected": {
          "onlightprimary": "#e10014",
          "onlightsecondary": "#e10014",
          "onlightbrandneutral": "#e10014"
        }
      }
    }
  }
}
export const textlinkicon = {
  "background": {
    "color": {
      "hover": {
        "onlightprimary": "rgba(170, 168, 163, .12)",
        "onlightsecondary": "rgba(170, 168, 163, .12)",
        "onlightbrandneutral": "rgba(170, 168, 163, .12)",
        "ondarkprimary": "rgba(221, 218, 212, .13)",
        "ondarksecondary": "rgba(221, 218, 212, .13)",
        "ondarkbrandhighlight": "rgba(0, 0, 0, .05)"
      }
    }
  }
}
export const tiles = {
  "standard": {
    "border": {
      "radius": "0.75rem"
    }
  },
  "hero": {
    "border": {
      "radius": "1.5rem"
    }
  },
  "shadow": {
    "subtle": {
      "lightbackground": {
        "base": {
          "onlightprimary": "0px 2px 20px 1px rgba(0, 0, 0, 0.02)",
          "onlightsecondary": "0px 2px 20px 1px rgba(0, 0, 0, 0.02)",
          "onlightbrandneutral": "0px 2px 20px 1px rgba(0, 0, 0, 0.02)"
        },
        "active": {
          "onlightprimary": "0px 1px 15px 1px rgba(0, 0, 0, 0.04)",
          "onlightsecondary": "0px 1px 15px 1px rgba(0, 0, 0, 0.04)",
          "onlightbrandneutral": "0px 1px 15px 1px rgba(0, 0, 0, 0.04)"
        },
        "hover": {
          "onlightprimary": "0px 3px 25px 1px rgba(0, 0, 0, 0.02)",
          "onlightsecondary": "0px 3px 25px 1px rgba(0, 0, 0, 0.02)",
          "onlightbrandneutral": "0px 3px 25px 1px rgba(0, 0, 0, 0.02)"
        },
        "hoveractive": {
          "onlightprimary": "0px 2px 19px 1px rgba(0, 0, 0, 0.04)",
          "onlightsecondary": "0px 2px 19px 1px rgba(0, 0, 0, 0.04)",
          "onlightbrandneutral": "0px 2px 19px 1px rgba(0, 0, 0, 0.04)"
        }
      }
    },
    "moderate": {
      "lightbackground": {
        "base": {
          "onlightprimary": "0px 2px 20px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 2px 20px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 2px 20px 0px rgba(0, 0, 0, 0.06)"
        },
        "active": {
          "onlightprimary": "0px 1px 15px 0px rgba(0, 0, 0, 0.08)",
          "onlightsecondary": "0px 1px 15px 0px rgba(0, 0, 0, 0.08)",
          "onlightbrandneutral": "0px 1px 15px 0px rgba(0, 0, 0, 0.08)"
        },
        "hover": {
          "onlightprimary": "0px 3px 25px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 3px 25px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 3px 25px 0px rgba(0, 0, 0, 0.06)"
        },
        "hoveractive": {
          "onlightprimary": "0px 2px 19px 0px rgba(0, 0, 0, 0.08)",
          "onlightsecondary": "0px 2px 19px 0px rgba(0, 0, 0, 0.08)",
          "onlightbrandneutral": "0px 2px 19px 0px rgba(0, 0, 0, 0.08)"
        }
      },
      "darkbackground": {
        "base": {
          "onlightprimary": "0px 2px 20px 0px rgba(0, 0, 0, 0.16)",
          "onlightsecondary": "0px 2px 20px 0px rgba(0, 0, 0, 0.16)",
          "onlightbrandneutral": "0px 2px 20px 0px rgba(0, 0, 0, 0.16)"
        },
        "active": {
          "onlightprimary": "0px 1px 15px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 1px 15px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 1px 15px 0px rgba(0, 0, 0, 0.18)"
        },
        "hover": {
          "onlightprimary": "0px 3px 25px 0px rgba(0, 0, 0, 0.16)",
          "onlightsecondary": "0px 3px 25px 0px rgba(0, 0, 0, 0.16)",
          "onlightbrandneutral": "0px 3px 25px 0px rgba(0, 0, 0, 0.16)"
        },
        "hoveractive": {
          "onlightprimary": "0px 2px 19px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 2px 19px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 2px 19px 0px rgba(0, 0, 0, 0.18)"
        }
      }
    }
  }
}
export const toggle = {
  "track": {
    "background": {
      "color": {
        "onlightprimary": "rgba(51, 51, 50, 0.5)",
        "onlightsecondary": "rgba(51, 51, 50, 0.5)",
        "onlightbrandneutral": "rgba(51, 51, 50, 0.5)",
        "ondarkprimary": "rgba(51, 51, 50, 0.5)",
        "ondarksecondary": "rgba(51, 51, 50, 0.5)",
        "ondarkbrandhighlight": "rgba(51, 51, 50, 0.4)",
        "selected": {
          "onlightprimary": "#00b845",
          "onlightsecondary": "#00b845",
          "onlightbrandneutral": "#00b845",
          "ondarkprimary": "#00b845",
          "ondarksecondary": "#00b845",
          "ondarkbrandhighlight": "#00b845"
        }
      }
    },
    "border": {
      "color": {
        "onlightprimary": "rgba(0, 0, 0, 0.2)",
        "onlightsecondary": "rgba(0, 0, 0, 0.2)",
        "onlightbrandneutral": "rgba(0, 0, 0, 0.2)",
        "ondarkprimary": "rgba(255, 255, 255, 0.35)",
        "ondarksecondary": "rgba(255, 255, 255, 0.35)",
        "ondarkbrandhighlight": "rgba(255, 255, 255, 0.78)",
        "selected": {
          "onlightprimary": "rgba(0, 0, 0, 0.25)",
          "onlightsecondary": "rgba(0, 0, 0, 0.25)",
          "onlightbrandneutral": "rgba(0, 0, 0, 0.25)",
          "ondarkprimary": "rgba(255, 255, 255, 0.6)",
          "ondarksecondary": "rgba(255, 255, 255, 0.6)",
          "ondarkbrandhighlight": "rgba(255, 255, 255, 0.6)"
        }
      }
    }
  }
}
export const tooltip = {
  "overlay": {
    "color": {
      "light": "rgba(0, 0, 0, 0.4)",
      "dark": "rgba(0, 0, 0, 0.6)"
    }
  }
}
export const interactive = {
  "focusring": {
    "style": "dashed",
    "offset": "0.125rem",
    "width": "0.0625rem",
    "color": {
      "onlightprimary": "#000000",
      "onlightsecondary": "#000000",
      "onlightbrandneutral": "#000000",
      "ondarkprimary": "#ffffff",
      "ondarksecondary": "#ffffff",
      "ondarkbrandhighlight": "#ffffff"
    }
  },
  "opacity": {
    "active": {
      "onlightprimary": "60%",
      "onlightsecondary": "60%",
      "onlightbrandneutral": "60%",
      "ondarkprimary": "60%",
      "ondarksecondary": "60%",
      "ondarkbrandhighlight": "100%"
    },
    "disabled": {
      "onlightprimary": "17%",
      "onlightsecondary": "17%",
      "onlightbrandneutral": "17%",
      "ondarkprimary": "17%",
      "ondarksecondary": "17%",
      "ondarkbrandhighlight": "40%"
    }
  }
}
export const shadow = {
  "elevation": {
    "middle": {
      "lightbackground": {
        "base": {
          "onlightprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarkprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarksecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarkbrandhighlight": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
        },
        "active": {
          "onlightprimary": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)",
          "ondarkprimary": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)",
          "ondarksecondary": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)",
          "ondarkbrandhighlight": "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
        },
        "hover": {
          "onlightprimary": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)",
          "ondarkprimary": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)",
          "ondarksecondary": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)",
          "ondarkbrandhighlight": "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
        },
        "hoveractive": {
          "onlightprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "onlightsecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "onlightbrandneutral": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarkprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarksecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)",
          "ondarkbrandhighlight": "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
        }
      },
      "darkbackground": {
        "base": {
          "onlightprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "onlightsecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "onlightbrandneutral": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarkprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarksecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarkbrandhighlight": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
        },
        "active": {
          "onlightprimary": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)",
          "onlightsecondary": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)",
          "onlightbrandneutral": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)",
          "ondarkprimary": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)",
          "ondarksecondary": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)",
          "ondarkbrandhighlight": "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
        },
        "hover": {
          "onlightprimary": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)",
          "onlightsecondary": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)",
          "onlightbrandneutral": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)",
          "ondarkprimary": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)",
          "ondarksecondary": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)",
          "ondarkbrandhighlight": "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
        },
        "hoveractive": {
          "onlightprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "onlightsecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "onlightbrandneutral": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarkprimary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarksecondary": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)",
          "ondarkbrandhighlight": "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
        }
      }
    },
    "high": {
      "lightbackground": {
        "base": {
          "onlightprimary": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "onlightsecondary": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "onlightbrandneutral": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "ondarkprimary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
        },
        "active": {
          "onlightprimary": "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)",
          "onlightsecondary": "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)",
          "onlightbrandneutral": "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)",
          "ondarkprimary": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
        },
        "hover": {
          "onlightprimary": "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)",
          "onlightsecondary": "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)",
          "onlightbrandneutral": "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)",
          "ondarkprimary": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
        },
        "hoveractive": {
          "onlightprimary": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "onlightsecondary": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "onlightbrandneutral": "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)",
          "ondarkprimary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
        }
      },
      "darkbackground": {
        "base": {
          "onlightprimary": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "ondarkprimary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
        },
        "active": {
          "onlightprimary": "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)",
          "ondarkprimary": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
        },
        "hover": {
          "onlightprimary": "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)",
          "ondarkprimary": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
        },
        "hoveractive": {
          "onlightprimary": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "onlightsecondary": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "onlightbrandneutral": "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)",
          "ondarkprimary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarksecondary": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)",
          "ondarkbrandhighlight": "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
        }
      }
    }
  }
}
export const space = {
  "halfx": "0.125rem",
  "1x": "0.25rem",
  "2x": "0.5rem",
  "3x": "0.75rem",
  "4x": "1rem",
  "6x": "1.5rem",
  "8x": "2rem",
  "12x": "3rem",
  "16x": "4rem",
  "24x": "6rem",
  "32x": "8rem"
}
export const size = {
  "border": {
    "radius": {
      "0": "0",
      "50": "0.125rem",
      "100": "0.25rem",
      "200": "0.5rem",
      "250": "0.625rem",
      "300": "0.75rem",
      "400": "1rem",
      "600": "1.5rem",
      "800": "2rem",
      "max": "624.9375rem"
    },
    "width": "0.0625rem"
  }
}
export const typography = {
  "body": {
    "large": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "1rem",
      "lineheight": "1.25rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "0.03125rem",
        "regular": "0.03125rem"
      }
    },
    "medium": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "0.875rem",
      "lineheight": "1.125rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "0.03125rem",
        "regular": "0.03125rem"
      }
    },
    "small": {
      "fontfamily": "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
      "fontsize": "0.75rem",
      "lineheight": "1rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "normal"
      }
    }
  },
  "feature": {
    "xlarge": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "9rem",
      "lineheight": "8.5rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "large": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "8rem",
      "lineheight": "7.5rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "medium": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "6rem",
      "lineheight": "5.5rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "small": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "5rem",
      "lineheight": "4.75rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    }
  },
  "fontfamily": {
    "edisplay": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
    "etext": "Verizon-NHG-eTX, Helvetica, Arial, sans-serif"
  },
  "fontweight": {
    "bold": "700",
    "regular": "400",
    "light": "300"
  },
  "letterspacing": {
    "wide": "0.03125rem",
    "semiwide": "0.015625rem",
    "normal": "normal"
  },
  "micro": {
    "fontfamily": "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
    "fontsize": "0.6875rem",
    "lineheight": "1rem",
    "fontweight": {
      "bold": "700",
      "regular": "400"
    },
    "letterspacing": {
      "bold": "normal",
      "regular": "normal"
    }
  },
  "title": {
    "2xlarge": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "4rem",
      "lineheight": "4rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "xlarge": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "3rem",
      "lineheight": "3rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "large": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "2.5rem",
      "lineheight": "2.5rem",
      "fontweight": {
        "bold": "700",
        "regular": "300"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "0.015625rem"
      }
    },
    "medium": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "2rem",
      "lineheight": "2.25rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "normal"
      }
    },
    "small": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "1.5rem",
      "lineheight": "1.75rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "normal"
      }
    },
    "xsmall": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "1.25rem",
      "lineheight": "1.5rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "normal"
      }
    },
    "2xsmall": {
      "fontfamily": "Verizon-NHG-DS, Helvetica, Arial, sans-serif",
      "fontsize": "1rem",
      "lineheight": "1.25rem",
      "fontweight": {
        "bold": "700",
        "regular": "400"
      },
      "letterspacing": {
        "bold": "normal",
        "regular": "normal"
      }
    }
  }
}
export const color_avatar_neutral_light = "#ffffff"
export const color_avatar_neutral_dark = "#000000"
export const color_avatar_gray_light = "#dddad4"
export const color_avatar_gray_dark = "#333332"
export const color_avatar_blue_light = "#aad8f9"
export const color_avatar_blue_dark = "#003e6c"
export const color_avatar_green_light = "#a4e6bd"
export const color_avatar_green_dark = "#004b1c"
export const color_avatar_yellow_light = "#fff1c2"
export const color_avatar_yellow_dark = "#685106"
export const color_avatar_orange_light = "#ffcaaa"
export const color_avatar_orange_dark = "#732706"
export const color_avatar_pink_light = "#ffc0e2"
export const color_avatar_pink_dark = "#681d45"
export const color_avatar_purple_light = "#d9c1f7"
export const color_avatar_purple_dark = "#381c5c"
export const color_avatar_iris_light = "#b8c5ff"
export const color_avatar_iris_dark = "#1f216a"
export const color_avatar_red_light = "#fabbc3"
export const color_avatar_red_dark = "#860011"
export const color_background_lowcontrast_onlightprimary = "rgba(170, 168, 163, .12)"
export const color_background_lowcontrast_onlightsecondary = "rgba(170, 168, 163, .12)"
export const color_background_lowcontrast_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const color_background_lowcontrast_ondarkprimary = "rgba(221, 218, 212, .13)"
export const color_background_lowcontrast_ondarksecondary = "rgba(221, 218, 212, .13)"
export const color_background_lowcontrast_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const color_dataviz_blue_200 = "#aad8f9"
export const color_dataviz_blue_400 = "#5ab3f3"
export const color_dataviz_blue_600 = "#0089ec"
export const color_dataviz_blue_800 = "#006fc0"
export const color_dataviz_blue_1000 = "#003e6c"
export const color_dataviz_green_200 = "#a4e6bd"
export const color_dataviz_green_400 = "#59d186"
export const color_dataviz_green_600 = "#00b845"
export const color_dataviz_green_800 = "#008331"
export const color_dataviz_green_1000 = "#004b1c"
export const color_dataviz_yellow_200 = "#fff1c2"
export const color_dataviz_yellow_400 = "#ffe797"
export const color_dataviz_yellow_600 = "#ffcd27"
export const color_dataviz_yellow_800 = "#b88f0b"
export const color_dataviz_yellow_1000 = "#685106"
export const color_dataviz_orange_200 = "#ffcaaa"
export const color_dataviz_orange_400 = "#ffa46d"
export const color_dataviz_orange_600 = "#ff8027"
export const color_dataviz_orange_800 = "#b95319"
export const color_dataviz_orange_1000 = "#732706"
export const color_dataviz_pink_200 = "#ffc0e2"
export const color_dataviz_pink_400 = "#fe86c7"
export const color_dataviz_pink_600 = "#fe46aa"
export const color_dataviz_pink_800 = "#bb337d"
export const color_dataviz_pink_1000 = "#681d45"
export const color_dataviz_purple_200 = "#d9c1f7"
export const color_dataviz_purple_400 = "#b689f0"
export const color_dataviz_purple_600 = "#8e48e8"
export const color_dataviz_purple_800 = "#6b36ae"
export const color_dataviz_purple_1000 = "#381c5c"
export const color_element_primary_onlightprimary = "#000000"
export const color_element_primary_ondarkprimary = "#ffffff"
export const color_element_primary_onlightsecondary = "#000000"
export const color_element_primary_ondarksecondary = "#ffffff"
export const color_element_primary_onlightbrandneutral = "#000000"
export const color_element_primary_ondarkbrandhighlight = "#ffffff"
export const color_element_secondary_onlightprimary = "#716f6d"
export const color_element_secondary_ondarkprimary = "#aaa8a3"
export const color_element_secondary_onlightsecondary = "#716f6d"
export const color_element_secondary_ondarksecondary = "#aaa8a3"
export const color_element_secondary_onlightbrandneutral = "#716f6d"
export const color_element_secondary_ondarkbrandhighlight = "#ffffff"
export const color_element_lowcontrast_onlightprimary = "rgba(170, 168, 163, 0.40)"
export const color_element_lowcontrast_ondarkprimary = "rgba(221, 218, 212, 0.23)"
export const color_element_lowcontrast_onlightsecondary = "rgba(170, 168, 163, 0.40)"
export const color_element_lowcontrast_ondarksecondary = "rgba(221, 218, 212, 0.23)"
export const color_element_lowcontrast_onlightbrandneutral = "rgba(170, 168, 163, 0.40)"
export const color_element_lowcontrast_ondarkbrandhighlight = "#ff281e"
export const color_element_brandhighlight_onlightprimary = "#e10014"
export const color_element_brandhighlight_ondarkprimary = "#e10014"
export const color_element_brandhighlight_onlightsecondary = "#e10014"
export const color_element_brandhighlight_ondarksecondary = "#e10014"
export const color_element_brandhighlight_onlightbrandneutral = "#e10014"
export const color_element_brandhighlight_ondarkbrandhighlight = "#f8ff3c"
export const color_element_savings_onlightprimary = "#008331"
export const color_element_savings_ondarkprimary = "#00b845"
export const color_element_savings_onlightsecondary = "#008331"
export const color_element_savings_ondarksecondary = "#00b845"
export const color_element_savings_onlightbrandneutral = "#00722b"
export const color_element_savings_ondarkbrandhighlight = "#ffffff"
export const color_feedback_background_information_tonal_onlightprimary = "#aad8f9"
export const color_feedback_background_information_tonal_onlightsecondary = "#aad8f9"
export const color_feedback_background_information_tonal_onlightbrandneutral = "#aad8f9"
export const color_feedback_background_information_tonal_ondarkprimary = "#003e6c"
export const color_feedback_background_information_tonal_ondarksecondary = "#003e6c"
export const color_feedback_background_information_tonal_ondarkbrandhighlight = "#aad8f9"
export const color_feedback_background_success_tonal_onlightprimary = "#a4e6bd"
export const color_feedback_background_success_tonal_onlightsecondary = "#a4e6bd"
export const color_feedback_background_success_tonal_onlightbrandneutral = "#a4e6bd"
export const color_feedback_background_success_tonal_ondarkprimary = "#004b1c"
export const color_feedback_background_success_tonal_ondarksecondary = "#004b1c"
export const color_feedback_background_success_tonal_ondarkbrandhighlight = "#a4e6bd"
export const color_feedback_background_warning_tonal_onlightprimary = "#ffe797"
export const color_feedback_background_warning_tonal_onlightsecondary = "#ffe797"
export const color_feedback_background_warning_tonal_onlightbrandneutral = "#ffe797"
export const color_feedback_background_warning_tonal_ondarkprimary = "#685106"
export const color_feedback_background_warning_tonal_ondarksecondary = "#685106"
export const color_feedback_background_warning_tonal_ondarkbrandhighlight = "#ffe797"
export const color_feedback_background_error_tonal_onlightprimary = "#ffcaaa"
export const color_feedback_background_error_tonal_onlightsecondary = "#ffcaaa"
export const color_feedback_background_error_tonal_onlightbrandneutral = "#ffcaaa"
export const color_feedback_background_error_tonal_ondarkprimary = "#732706"
export const color_feedback_background_error_tonal_ondarksecondary = "#732706"
export const color_feedback_background_error_tonal_ondarkbrandhighlight = "#ffcaaa"
export const color_feedback_element_information_onlightprimary = "#006fc0"
export const color_feedback_element_information_onlightsecondary = "#006fc0"
export const color_feedback_element_information_onlightbrandneutral = "#006fc0"
export const color_feedback_element_information_ondarkprimary = "#0089ec"
export const color_feedback_element_information_ondarksecondary = "#0089ec"
export const color_feedback_element_information_ondarkbrandhighlight = "#ffffff"
export const color_feedback_element_information_tonal_onlightprimary = "#003e6c"
export const color_feedback_element_information_tonal_onlightsecondary = "#003e6c"
export const color_feedback_element_information_tonal_onlightbrandneutral = "#003e6c"
export const color_feedback_element_information_tonal_ondarkprimary = "#aad8f9"
export const color_feedback_element_information_tonal_ondarksecondary = "#aad8f9"
export const color_feedback_element_information_tonal_ondarkbrandhighlight = "#003e6c"
export const color_feedback_element_success_onlightprimary = "#008331"
export const color_feedback_element_success_onlightsecondary = "#008331"
export const color_feedback_element_success_onlightbrandneutral = "#00722b"
export const color_feedback_element_success_ondarkprimary = "#00b845"
export const color_feedback_element_success_ondarksecondary = "#00b845"
export const color_feedback_element_success_ondarkbrandhighlight = "#ffffff"
export const color_feedback_element_success_tonal_onlightprimary = "#004b1c"
export const color_feedback_element_success_tonal_onlightsecondary = "#004b1c"
export const color_feedback_element_success_tonal_onlightbrandneutral = "#004b1c"
export const color_feedback_element_success_tonal_ondarkprimary = "#a4e6bd"
export const color_feedback_element_success_tonal_ondarksecondary = "#a4e6bd"
export const color_feedback_element_success_tonal_ondarkbrandhighlight = "#004b1c"
export const color_feedback_element_warning_onlightprimary = "#ffcd27"
export const color_feedback_element_warning_onlightsecondary = "#ffcd27"
export const color_feedback_element_warning_onlightbrandneutral = "#ffcd27"
export const color_feedback_element_warning_ondarkprimary = "#ffcd27"
export const color_feedback_element_warning_ondarksecondary = "#ffcd27"
export const color_feedback_element_warning_ondarkbrandhighlight = "#ffffff"
export const color_feedback_element_warning_tonal_onlightprimary = "#685106"
export const color_feedback_element_warning_tonal_onlightsecondary = "#685106"
export const color_feedback_element_warning_tonal_onlightbrandneutral = "#685106"
export const color_feedback_element_warning_tonal_ondarkprimary = "#fff1c2"
export const color_feedback_element_warning_tonal_ondarksecondary = "#fff1c2"
export const color_feedback_element_warning_tonal_ondarkbrandhighlight = "#685106"
export const color_feedback_element_error_onlightprimary = "#b95319"
export const color_feedback_element_error_onlightsecondary = "#b95319"
export const color_feedback_element_error_onlightbrandneutral = "#a74815"
export const color_feedback_element_error_ondarkprimary = "#ff8027"
export const color_feedback_element_error_ondarksecondary = "#ff8027"
export const color_feedback_element_error_ondarkbrandhighlight = "#ffffff"
export const color_feedback_element_error_tonal_onlightprimary = "#732706"
export const color_feedback_element_error_tonal_onlightsecondary = "#732706"
export const color_feedback_element_error_tonal_onlightbrandneutral = "#732706"
export const color_feedback_element_error_tonal_ondarkprimary = "#ffcaaa"
export const color_feedback_element_error_tonal_ondarksecondary = "#ffcaaa"
export const color_feedback_element_error_tonal_ondarkbrandhighlight = "#732706"
export const color_black = "#000000"
export const color_white = "#ffffff"
export const color_standardred = "#e10014"
export const color_coral = "#ff281e"
export const color_neonyellow = "#f8ff3c"
export const color_stone = "#f8f3e9"
export const color_gray_100 = "#f8f7f5"
export const color_gray_200 = "#dddad4"
export const color_gray_400 = "#aaa8a3"
export const color_gray_600 = "#716f6d"
export const color_gray_900 = "#333332"
export const color_gray_1100 = "#1d1c1c"
export const color_orange_200 = "#ffcaaa"
export const color_orange_400 = "#ffa46d"
export const color_orange_600 = "#ff8027"
export const color_orange_800 = "#b95319"
export const color_orange_900 = "#a74815"
export const color_orange_1000 = "#732706"
export const color_yellow_200 = "#fff1c2"
export const color_yellow_400 = "#ffe797"
export const color_yellow_600 = "#ffcd27"
export const color_yellow_800 = "#b88f0b"
export const color_yellow_900 = "#a27e0a"
export const color_yellow_1000 = "#685106"
export const color_blue_200 = "#aad8f9"
export const color_blue_400 = "#5ab3f3"
export const color_blue_600 = "#0089ec"
export const color_blue_800 = "#006fc0"
export const color_blue_900 = "#005b9e"
export const color_blue_1000 = "#003e6c"
export const color_green_200 = "#a4e6bd"
export const color_green_400 = "#59d186"
export const color_green_600 = "#00b845"
export const color_green_800 = "#008331"
export const color_green_900 = "#00722b"
export const color_green_1000 = "#004b1c"
export const color_pink_200 = "#ffc0e2"
export const color_pink_400 = "#fe86c7"
export const color_pink_600 = "#fe46aa"
export const color_pink_800 = "#bb337d"
export const color_pink_900 = "#9d2b69"
export const color_pink_1000 = "#681d45"
export const color_purple_200 = "#d9c1f7"
export const color_purple_400 = "#b689f0"
export const color_purple_600 = "#8e48e8"
export const color_purple_800 = "#6b36ae"
export const color_purple_900 = "#572c8e"
export const color_purple_1000 = "#381c5c"
export const color_iris_200 = "#b8c5ff"
export const color_iris_400 = "#8496fa"
export const color_iris_600 = "#5055f0"
export const color_iris_800 = "#3e42be"
export const color_iris_900 = "#31359d"
export const color_iris_1000 = "#1f216a"
export const color_limitedred_200 = "#fabbc3"
export const color_limitedred_1000 = "#860011"
export const color_limitedred = "#ee001e"
export const color_surface_lightprimary = "#ffffff"
export const color_surface_lightsecondary = "#f8f7f5"
export const color_surface_lightbrandneutral = "#f8f3e9"
export const color_surface_darkprimary = "#000000"
export const color_surface_darksecondary = "#1d1c1c"
export const color_surface_darkbrandhighlight = "#e10014"
export const badgeindicator_small_text_lineheight = "0.75rem"
export const badgeindicator_medium_text_lineheight = "0.875rem"
export const badgeindicator_large_text_lineheight = "1rem"
export const badgeindicator_xlarge_text_lineheight = "1.25rem"
export const badgeindicator_2xlarge_text_lineheight = "1.5rem"
export const badges_border_color_onlightprimary = "#ffffff"
export const badges_border_color_onlightsecondary = "#f8f7f5"
export const badges_border_color_onlightbrandneutral = "#f8f3e9"
export const badges_border_color_ondarkprimary = "#000000"
export const badges_border_color_ondarksecondary = "#1d1c1c"
export const badges_border_color_ondarkbrandhighlight = "#e10014"
export const badges_text_color_onred_onlightprimary = "#ffffff"
export const badges_text_color_onred_onlightsecondary = "#ffffff"
export const badges_text_color_onred_onlightbrandneutral = "#ffffff"
export const badges_text_color_onred_ondarkprimary = "#ffffff"
export const badges_text_color_onred_ondarksecondary = "#ffffff"
export const badges_text_color_onred_ondarkbrandhighlight = "#ffffff"
export const badges_text_color_onyellow_onlightprimary = "#000000"
export const badges_text_color_onyellow_onlightsecondary = "#000000"
export const badges_text_color_onyellow_onlightbrandneutral = "#000000"
export const badges_text_color_onyellow_ondarkprimary = "#000000"
export const badges_text_color_onyellow_ondarksecondary = "#000000"
export const badges_text_color_onyellow_ondarkbrandhighlight = "#000000"
export const badges_text_color_ongreen_onlightprimary = "#ffffff"
export const badges_text_color_ongreen_onlightsecondary = "#ffffff"
export const badges_text_color_ongreen_onlightbrandneutral = "#ffffff"
export const badges_text_color_ongreen_ondarkprimary = "#000000"
export const badges_text_color_ongreen_ondarksecondary = "#000000"
export const badges_text_color_ongreen_ondarkbrandhighlight = "#000000"
export const badges_text_color_onorange_onlightprimary = "#ffffff"
export const badges_text_color_onorange_onlightsecondary = "#ffffff"
export const badges_text_color_onorange_onlightbrandneutral = "#ffffff"
export const badges_text_color_onorange_ondarkprimary = "#000000"
export const badges_text_color_onorange_ondarksecondary = "#000000"
export const badges_text_color_onorange_ondarkbrandhighlight = "#000000"
export const badges_text_color_onblue_onlightprimary = "#ffffff"
export const badges_text_color_onblue_onlightsecondary = "#ffffff"
export const badges_text_color_onblue_onlightbrandneutral = "#ffffff"
export const badges_text_color_onblue_ondarkprimary = "#000000"
export const badges_text_color_onblue_ondarksecondary = "#000000"
export const badges_text_color_onblue_ondarkbrandhighlight = "#000000"
export const badges_text_color_onneonyellow_onlightprimary = "#000000"
export const badges_text_color_onneonyellow_onlightsecondary = "#000000"
export const badges_text_color_onneonyellow_onlightbrandneutral = "#000000"
export const badges_text_color_onneonyellow_ondarkprimary = "#000000"
export const badges_text_color_onneonyellow_ondarksecondary = "#000000"
export const badges_text_color_onneonyellow_ondarkbrandhighlight = "#000000"
export const badges_text_color_onstone_onlightprimary = "#000000"
export const badges_text_color_onstone_onlightsecondary = "#000000"
export const badges_text_color_onstone_onlightbrandneutral = "#000000"
export const badges_text_color_onstone_ondarkprimary = "#000000"
export const badges_text_color_onstone_ondarksecondary = "#000000"
export const badges_text_color_onstone_ondarkbrandhighlight = "#000000"
export const badges_text_color_ongrayhighcontrast_onlightprimary = "#ffffff"
export const badges_text_color_ongrayhighcontrast_onlightsecondary = "#ffffff"
export const badges_text_color_ongrayhighcontrast_onlightbrandneutral = "#ffffff"
export const badges_text_color_ongrayhighcontrast_ondarkprimary = "#000000"
export const badges_text_color_ongrayhighcontrast_ondarksecondary = "#000000"
export const badges_text_color_ongrayhighcontrast_ondarkbrandhighlight = "#000000"
export const badges_text_color_ongraylowcontrast_onlightprimary = "#000000"
export const badges_text_color_ongraylowcontrast_onlightsecondary = "#000000"
export const badges_text_color_ongraylowcontrast_onlightbrandneutral = "#000000"
export const badges_text_color_ongraylowcontrast_ondarkprimary = "#ffffff"
export const badges_text_color_ongraylowcontrast_ondarksecondary = "#ffffff"
export const badges_text_color_ongraylowcontrast_ondarkbrandhighlight = "#ffffff"
export const badges_text_color_onwhite_onlightprimary = "#000000"
export const badges_text_color_onwhite_onlightsecondary = "#000000"
export const badges_text_color_onwhite_onlightbrandneutral = "#000000"
export const badges_text_color_onwhite_ondarkprimary = "#000000"
export const badges_text_color_onwhite_ondarksecondary = "#000000"
export const badges_text_color_onwhite_ondarkbrandhighlight = "#000000"
export const badges_text_color_onblack_onlightprimary = "#ffffff"
export const badges_text_color_onblack_onlightsecondary = "#ffffff"
export const badges_text_color_onblack_onlightbrandneutral = "#ffffff"
export const badges_text_color_onblack_ondarkprimary = "#ffffff"
export const badges_text_color_onblack_ondarksecondary = "#ffffff"
export const badges_text_color_onblack_ondarkbrandhighlight = "#ffffff"
export const badges_background_color_red_onlightprimary = "#e10014"
export const badges_background_color_red_onlightsecondary = "#e10014"
export const badges_background_color_red_onlightbrandneutral = "#e10014"
export const badges_background_color_red_ondarkprimary = "#e10014"
export const badges_background_color_red_ondarksecondary = "#e10014"
export const badges_background_color_red_ondarkbrandhighlight = "#e10014"
export const badges_background_color_yellow_onlightprimary = "#ffcd27"
export const badges_background_color_yellow_onlightsecondary = "#ffcd27"
export const badges_background_color_yellow_onlightbrandneutral = "#ffcd27"
export const badges_background_color_yellow_ondarkprimary = "#ffcd27"
export const badges_background_color_yellow_ondarksecondary = "#ffcd27"
export const badges_background_color_yellow_ondarkbrandhighlight = "#ffcd27"
export const badges_background_color_green_onlightprimary = "#008331"
export const badges_background_color_green_onlightsecondary = "#008331"
export const badges_background_color_green_onlightbrandneutral = "#00722b"
export const badges_background_color_green_ondarkprimary = "#00b845"
export const badges_background_color_green_ondarksecondary = "#00b845"
export const badges_background_color_green_ondarkbrandhighlight = "#00b845"
export const badges_background_color_orange_onlightprimary = "#b95319"
export const badges_background_color_orange_onlightsecondary = "#b95319"
export const badges_background_color_orange_onlightbrandneutral = "#a74815"
export const badges_background_color_orange_ondarkprimary = "#ff8027"
export const badges_background_color_orange_ondarksecondary = "#ff8027"
export const badges_background_color_orange_ondarkbrandhighlight = "#ff8027"
export const badges_background_color_blue_onlightprimary = "#006fc0"
export const badges_background_color_blue_onlightsecondary = "#006fc0"
export const badges_background_color_blue_onlightbrandneutral = "#006fc0"
export const badges_background_color_blue_ondarkprimary = "#0089ec"
export const badges_background_color_blue_ondarksecondary = "#0089ec"
export const badges_background_color_blue_ondarkbrandhighlight = "#0089ec"
export const badges_background_color_neonyellow_onlightprimary = "#f8ff3c"
export const badges_background_color_neonyellow_onlightsecondary = "#f8ff3c"
export const badges_background_color_neonyellow_onlightbrandneutral = "#f8ff3c"
export const badges_background_color_neonyellow_ondarkprimary = "#f8ff3c"
export const badges_background_color_neonyellow_ondarksecondary = "#f8ff3c"
export const badges_background_color_neonyellow_ondarkbrandhighlight = "#f8ff3c"
export const badges_background_color_stone_onlightprimary = "#f8f3e9"
export const badges_background_color_stone_onlightsecondary = "#f8f3e9"
export const badges_background_color_stone_onlightbrandneutral = "#f8f3e9"
export const badges_background_color_stone_ondarkprimary = "#f8f3e9"
export const badges_background_color_stone_ondarksecondary = "#f8f3e9"
export const badges_background_color_stone_ondarkbrandhighlight = "#f8f3e9"
export const badges_background_color_grayhighcontrast_onlightprimary = "#716f6d"
export const badges_background_color_grayhighcontrast_onlightsecondary = "#716f6d"
export const badges_background_color_grayhighcontrast_onlightbrandneutral = "#716f6d"
export const badges_background_color_grayhighcontrast_ondarkprimary = "#aaa8a3"
export const badges_background_color_grayhighcontrast_ondarksecondary = "#aaa8a3"
export const badges_background_color_grayhighcontrast_ondarkbrandhighlight = "#aaa8a3"
export const badges_background_color_graylowcontrast_onlightprimary = "#dddad4"
export const badges_background_color_graylowcontrast_onlightsecondary = "#dddad4"
export const badges_background_color_graylowcontrast_onlightbrandneutral = "#dddad4"
export const badges_background_color_graylowcontrast_ondarkprimary = "#333332"
export const badges_background_color_graylowcontrast_ondarksecondary = "#333332"
export const badges_background_color_graylowcontrast_ondarkbrandhighlight = "#333332"
export const badges_background_color_white_onlightprimary = "#ffffff"
export const badges_background_color_white_onlightsecondary = "#ffffff"
export const badges_background_color_white_onlightbrandneutral = "#ffffff"
export const badges_background_color_white_ondarkprimary = "#ffffff"
export const badges_background_color_white_ondarksecondary = "#ffffff"
export const badges_background_color_white_ondarkbrandhighlight = "#ffffff"
export const badges_background_color_black_onlightprimary = "#000000"
export const badges_background_color_black_onlightsecondary = "#000000"
export const badges_background_color_black_onlightbrandneutral = "#000000"
export const badges_background_color_black_ondarkprimary = "#000000"
export const badges_background_color_black_ondarksecondary = "#000000"
export const badges_background_color_black_ondarkbrandhighlight = "#000000"
export const button_primary_background_color_onlightprimary = "#000000"
export const button_primary_background_color_onlightsecondary = "#000000"
export const button_primary_background_color_onlightbrandneutral = "#000000"
export const button_primary_background_color_ondarkprimary = "#ffffff"
export const button_primary_background_color_ondarksecondary = "#ffffff"
export const button_primary_background_color_ondarkbrandhighlight = "#ffffff"
export const button_primary_label_color_onlightprimary = "#ffffff"
export const button_primary_label_color_onlightsecondary = "#ffffff"
export const button_primary_label_color_onlightbrandneutral = "#ffffff"
export const button_primary_label_color_ondarkprimary = "#000000"
export const button_primary_label_color_ondarksecondary = "#000000"
export const button_primary_label_color_ondarkbrandhighlight = "#000000"
export const button_primary_border_color_onlightprimary = "#000000"
export const button_primary_border_color_onlightsecondary = "#000000"
export const button_primary_border_color_onlightbrandneutral = "#000000"
export const button_primary_border_color_ondarkprimary = "#ffffff"
export const button_primary_border_color_ondarksecondary = "#ffffff"
export const button_primary_border_color_ondarkbrandhighlight = "#ffffff"
export const button_secondary_background_color_onlightprimary = "transparent"
export const button_secondary_background_color_onlightsecondary = "transparent"
export const button_secondary_background_color_onlightbrandneutral = "transparent"
export const button_secondary_background_color_ondarkprimary = "transparent"
export const button_secondary_background_color_ondarksecondary = "transparent"
export const button_secondary_background_color_ondarkbrandhighlight = "transparent"
export const button_secondary_label_color_onlightprimary = "#000000"
export const button_secondary_label_color_onlightsecondary = "#000000"
export const button_secondary_label_color_onlightbrandneutral = "#000000"
export const button_secondary_label_color_ondarkprimary = "#ffffff"
export const button_secondary_label_color_ondarksecondary = "#ffffff"
export const button_secondary_label_color_ondarkbrandhighlight = "#ffffff"
export const button_secondary_border_color_onlightprimary = "#000000"
export const button_secondary_border_color_onlightsecondary = "#000000"
export const button_secondary_border_color_onlightbrandneutral = "#000000"
export const button_secondary_border_color_ondarkprimary = "#ffffff"
export const button_secondary_border_color_ondarksecondary = "#ffffff"
export const button_secondary_border_color_ondarkbrandhighlight = "#ffffff"
export const buttonicon_ghost_background_color_hover_onlightprimary = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_background_color_hover_onlightsecondary = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_background_color_hover_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_background_color_hover_ondarkprimary = "rgba(221, 218, 212, .13)"
export const buttonicon_ghost_background_color_hover_ondarksecondary = "rgba(221, 218, 212, .13)"
export const buttonicon_ghost_background_color_hover_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const buttonicon_ghost_background_color_onlightprimary = "transparent"
export const buttonicon_ghost_background_color_onlightsecondary = "transparent"
export const buttonicon_ghost_background_color_onlightbrandneutral = "transparent"
export const buttonicon_ghost_background_color_ondarkprimary = "transparent"
export const buttonicon_ghost_background_color_ondarksecondary = "transparent"
export const buttonicon_ghost_background_color_ondarkbrandhighlight = "transparent"
export const buttonicon_ghost_border_color_hover_onlightprimary = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_border_color_hover_onlightsecondary = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_border_color_hover_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const buttonicon_ghost_border_color_hover_ondarkprimary = "rgba(221, 218, 212, .13)"
export const buttonicon_ghost_border_color_hover_ondarksecondary = "rgba(221, 218, 212, .13)"
export const buttonicon_ghost_border_color_hover_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const buttonicon_ghost_focusring_color_inside_onlightprimary = "#000000"
export const buttonicon_ghost_focusring_color_inside_onlightsecondary = "#000000"
export const buttonicon_ghost_focusring_color_inside_onlightbrandneutral = "#000000"
export const buttonicon_ghost_focusring_color_inside_ondarkprimary = "#ffffff"
export const buttonicon_ghost_focusring_color_inside_ondarksecondary = "#ffffff"
export const buttonicon_ghost_focusring_color_inside_ondarkbrandhighlight = "#ffffff"
export const buttonicon_lowcontrasttonal_background_color_floating_onlightprimary = "#ffffff"
export const buttonicon_lowcontrasttonal_background_color_floating_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrasttonal_background_color_floating_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrasttonal_background_color_floating_ondarkprimary = "#333332"
export const buttonicon_lowcontrasttonal_background_color_floating_ondarksecondary = "#333332"
export const buttonicon_lowcontrasttonal_background_color_floating_ondarkbrandhighlight = "#333332"
export const buttonicon_lowcontrasttonal_background_color_onlightprimary = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_background_color_onlightsecondary = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_background_color_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_background_color_ondarkprimary = "rgba(221, 218, 212, .13)"
export const buttonicon_lowcontrasttonal_background_color_ondarksecondary = "rgba(221, 218, 212, .13)"
export const buttonicon_lowcontrasttonal_background_color_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const buttonicon_lowcontrasttonal_border_color_onlightprimary = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_border_color_onlightsecondary = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_border_color_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const buttonicon_lowcontrasttonal_border_color_ondarkprimary = "rgba(221, 168, 163, .13)"
export const buttonicon_lowcontrasttonal_border_color_ondarksecondary = "rgba(221, 218, 212, .13)"
export const buttonicon_lowcontrasttonal_border_color_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const buttonicon_lowcontrasttonal_border_color_floating_onlightprimary = "#ffffff"
export const buttonicon_lowcontrasttonal_border_color_floating_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrasttonal_border_color_floating_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrasttonal_border_color_floating_ondarkprimary = "#333332"
export const buttonicon_lowcontrasttonal_border_color_floating_ondarksecondary = "#333332"
export const buttonicon_lowcontrasttonal_border_color_floating_ondarkbrandhighlight = "#333332"
export const buttonicon_lowcontrasttonal_focusring_color_inside_onlightprimary = "#000000"
export const buttonicon_lowcontrasttonal_focusring_color_inside_onlightsecondary = "#000000"
export const buttonicon_lowcontrasttonal_focusring_color_inside_onlightbrandneutral = "#000000"
export const buttonicon_lowcontrasttonal_focusring_color_inside_ondarkprimary = "#ffffff"
export const buttonicon_lowcontrasttonal_focusring_color_inside_ondarksecondary = "#ffffff"
export const buttonicon_lowcontrasttonal_focusring_color_inside_ondarkbrandhighlight = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_onlightprimary = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_ondarkprimary = "#000000"
export const buttonicon_lowcontrastsolid_background_color_ondarksecondary = "#000000"
export const buttonicon_lowcontrastsolid_background_color_ondarkbrandhighlight = "#000000"
export const buttonicon_lowcontrastsolid_background_color_floating_onlightprimary = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_floating_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_floating_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrastsolid_background_color_floating_ondarkprimary = "#333332"
export const buttonicon_lowcontrastsolid_background_color_floating_ondarksecondary = "#333332"
export const buttonicon_lowcontrastsolid_background_color_floating_ondarkbrandhighlight = "#333332"
export const buttonicon_lowcontrastsolid_border_color_visible_onlightprimary = "#dddad4"
export const buttonicon_lowcontrastsolid_border_color_visible_onlightsecondary = "#dddad4"
export const buttonicon_lowcontrastsolid_border_color_visible_onlightbrandneutral = "#dddad4"
export const buttonicon_lowcontrastsolid_border_color_visible_ondarkprimary = "#333332"
export const buttonicon_lowcontrastsolid_border_color_visible_ondarksecondary = "#333332"
export const buttonicon_lowcontrastsolid_border_color_visible_ondarkbrandhighlight = "#333332"
export const buttonicon_lowcontrastsolid_border_color_onlightprimary = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_ondarkprimary = "#000000"
export const buttonicon_lowcontrastsolid_border_color_ondarksecondary = "#000000"
export const buttonicon_lowcontrastsolid_border_color_ondarkbrandhighlight = "#000000"
export const buttonicon_lowcontrastsolid_border_color_floating_onlightprimary = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_floating_onlightsecondary = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_floating_onlightbrandneutral = "#ffffff"
export const buttonicon_lowcontrastsolid_border_color_floating_ondarkprimary = "#333332"
export const buttonicon_lowcontrastsolid_border_color_floating_ondarksecondary = "#333332"
export const buttonicon_lowcontrastsolid_border_color_floating_ondarkbrandhighlight = "#333332"
export const buttonicon_lowcontrastsolid_focusring_color_inside_onlightprimary = "#000000"
export const buttonicon_lowcontrastsolid_focusring_color_inside_onlightsecondary = "#000000"
export const buttonicon_lowcontrastsolid_focusring_color_inside_onlightbrandneutral = "#000000"
export const buttonicon_lowcontrastsolid_focusring_color_inside_ondarkprimary = "#ffffff"
export const buttonicon_lowcontrastsolid_focusring_color_inside_ondarksecondary = "#ffffff"
export const buttonicon_lowcontrastsolid_focusring_color_inside_ondarkbrandhighlight = "#ffffff"
export const buttonicon_highcontrast_icon_color_onlightprimary = "#ffffff"
export const buttonicon_highcontrast_icon_color_onlightsecondary = "#ffffff"
export const buttonicon_highcontrast_icon_color_onlightbrandneutral = "#ffffff"
export const buttonicon_highcontrast_icon_color_ondarkprimary = "#000000"
export const buttonicon_highcontrast_icon_color_ondarksecondary = "#000000"
export const buttonicon_highcontrast_icon_color_ondarkbrandhighlight = "#000000"
export const buttonicon_highcontrast_background_color_onlightprimary = "#000000"
export const buttonicon_highcontrast_background_color_onlightsecondary = "#000000"
export const buttonicon_highcontrast_background_color_onlightbrandneutral = "#000000"
export const buttonicon_highcontrast_background_color_ondarkprimary = "#ffffff"
export const buttonicon_highcontrast_background_color_ondarksecondary = "#ffffff"
export const buttonicon_highcontrast_background_color_ondarkbrandhighlight = "#ffffff"
export const buttonicon_highcontrast_background_color_floating_onlightprimary = "#333332"
export const buttonicon_highcontrast_background_color_floating_onlightsecondary = "#333332"
export const buttonicon_highcontrast_background_color_floating_onlightbrandneutral = "#333332"
export const buttonicon_highcontrast_background_color_floating_ondarkprimary = "#ffffff"
export const buttonicon_highcontrast_background_color_floating_ondarksecondary = "#ffffff"
export const buttonicon_highcontrast_background_color_floating_ondarkbrandhighlight = "#ffffff"
export const buttonicon_highcontrast_border_color_onlightprimary = "#000000"
export const buttonicon_highcontrast_border_color_onlightsecondary = "#000000"
export const buttonicon_highcontrast_border_color_onlightbrandneutral = "#000000"
export const buttonicon_highcontrast_border_color_ondarkprimary = "#ffffff"
export const buttonicon_highcontrast_border_color_ondarksecondary = "#ffffff"
export const buttonicon_highcontrast_border_color_ondarkbrandhighlight = "#ffffff"
export const buttonicon_highcontrast_border_color_floating_onlightprimary = "#333332"
export const buttonicon_highcontrast_border_color_floating_onlightsecondary = "#333332"
export const buttonicon_highcontrast_border_color_floating_onlightbrandneutral = "#333332"
export const buttonicon_highcontrast_border_color_floating_ondarkprimary = "#ffffff"
export const buttonicon_highcontrast_border_color_floating_ondarksecondary = "#ffffff"
export const buttonicon_highcontrast_border_color_floating_ondarkbrandhighlight = "#ffffff"
export const buttonicon_highcontrast_focusring_color_inside_onlightprimary = "#ffffff"
export const buttonicon_highcontrast_focusring_color_inside_onlightsecondary = "#ffffff"
export const buttonicon_highcontrast_focusring_color_inside_onlightbrandneutral = "#ffffff"
export const buttonicon_highcontrast_focusring_color_inside_ondarkprimary = "#000000"
export const buttonicon_highcontrast_focusring_color_inside_ondarksecondary = "#000000"
export const buttonicon_highcontrast_focusring_color_inside_ondarkbrandhighlight = "#000000"
export const calendar_date_background_color_selected_onlightprimary = "#000000"
export const calendar_date_background_color_selected_onlightsecondary = "#000000"
export const calendar_date_background_color_selected_onlightbrandneutral = "#000000"
export const calendar_date_background_color_selected_ondarkprimary = "#ffffff"
export const calendar_date_background_color_selected_ondarksecondary = "#ffffff"
export const calendar_date_background_color_selected_highlight_onlightprimary = "#e10014"
export const calendar_date_background_color_selected_highlight_onlightsecondary = "#e10014"
export const calendar_date_background_color_selected_highlight_onlightbrandneutral = "#e10014"
export const calendar_date_background_color_selected_highlight_ondarkprimary = "#ffffff"
export const calendar_date_background_color_selected_highlight_ondarksecondary = "#ffffff"
export const calendar_date_background_color_hover_onlightprimary = "rgba(170, 168, 163, .12)"
export const calendar_date_background_color_hover_onlightsecondary = "rgba(170, 168, 163, .12)"
export const calendar_date_background_color_hover_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const calendar_date_background_color_hover_ondarkprimary = "rgba(221, 218, 212, .13)"
export const calendar_date_background_color_hover_ondarksecondary = "rgba(221, 218, 212, .13)"
export const calendar_date_label_color_selected_onlightprimary = "#ffffff"
export const calendar_date_label_color_selected_onlightsecondary = "#ffffff"
export const calendar_date_label_color_selected_onlightbrandneutral = "#ffffff"
export const calendar_date_label_color_selected_ondarkprimary = "#000000"
export const calendar_date_label_color_selected_ondarksecondary = "#000000"
export const calendar_date_label_color_selected_highlight_onlightprimary = "#ffffff"
export const calendar_date_label_color_selected_highlight_onlightsecondary = "#ffffff"
export const calendar_date_label_color_selected_highlight_onlightbrandneutral = "#ffffff"
export const calendar_date_label_color_selected_highlight_ondarkprimary = "#000000"
export const calendar_date_label_color_selected_highlight_ondarksecondary = "#000000"
export const calendar_date_indicator_color_selected_onlightprimary = "#ffffff"
export const calendar_date_indicator_color_selected_onlightsecondary = "#ffffff"
export const calendar_date_indicator_color_selected_onlightbrandneutral = "#ffffff"
export const calendar_date_indicator_color_selected_ondarkprimary = "#000000"
export const calendar_date_indicator_color_selected_ondarksecondary = "#000000"
export const calendar_date_indicator_color_highlight_onlightprimary = "#e10014"
export const calendar_date_indicator_color_highlight_onlightsecondary = "#e10014"
export const calendar_date_indicator_color_highlight_onlightbrandneutral = "#e10014"
export const carouselscrollbar_trackoverlay_color_onlightprimary = "rgba(0, 0, 0, 0.15)"
export const carouselscrollbar_trackoverlay_color_onlightsecondary = "rgba(0, 0, 0, 0.15)"
export const carouselscrollbar_trackoverlay_color_onlightbrandneutral = "rgba(0, 0, 0, 0.15)"
export const carouselscrollbar_trackoverlay_color_ondarkprimary = "rgba(255, 255, 255, 0.15)"
export const carouselscrollbar_trackoverlay_color_ondarksecondary = "rgba(255, 255, 255, 0.15)"
export const carouselscrollbar_trackoverlay_color_ondarkbrandhighlight = "rgba(255, 255, 255, 0.20)"
export const carouselscrollbar_thumb_color_onlightprimary = "#716f6d"
export const carouselscrollbar_thumb_color_onlightsecondary = "#716f6d"
export const carouselscrollbar_thumb_color_onlightbrandneutral = "#716f6d"
export const carouselscrollbar_thumb_color_ondarkprimary = "#aaa8a3"
export const carouselscrollbar_thumb_color_ondarksecondary = "#aaa8a3"
export const carouselscrollbar_thumb_color_ondarkbrandhighlight = "#ffffff"
export const carouselscrollbar_track_color_onlightprimary = "#aaa8a3"
export const carouselscrollbar_track_color_onlightsecondary = "#aaa8a3"
export const carouselscrollbar_track_color_onlightbrandneutral = "#aaa8a3"
export const carouselscrollbar_track_color_ondarkprimary = "#dddad4"
export const carouselscrollbar_track_color_ondarksecondary = "#dddad4"
export const carouselscrollbar_track_color_ondarkbrandhighlight = "#ff281e"
export const checkbox_icon_color_selected_onlightprimary = "#ffffff"
export const checkbox_icon_color_selected_onlightsecondary = "#ffffff"
export const checkbox_icon_color_selected_onlightbrandneutral = "#ffffff"
export const checkbox_icon_color_selected_ondarkprimary = "#000000"
export const checkbox_icon_color_selected_ondarksecondary = "#000000"
export const checkbox_icon_color_selected_ondarkbrandhighlight = "#000000"
export const checkbox_background_color_selected_onlightprimary = "#000000"
export const checkbox_background_color_selected_onlightsecondary = "#000000"
export const checkbox_background_color_selected_onlightbrandneutral = "#000000"
export const checkbox_background_color_selected_ondarkprimary = "#ffffff"
export const checkbox_background_color_selected_ondarksecondary = "#ffffff"
export const checkbox_background_color_selected_ondarkbrandhighlight = "#ffffff"
export const forms_border_color_error_tonal_onlightprimary = "#732706"
export const forms_border_color_error_tonal_onlightsecondary = "#732706"
export const forms_border_color_error_tonal_onlightbrandneutral = "#732706"
export const forms_border_color_error_tonal_ondarkprimary = "#ffcaaa"
export const forms_border_color_error_tonal_ondarksecondary = "#ffcaaa"
export const forms_border_color_error_tonal_ondarkbrandhighlight = "#ffcaaa"
export const forms_border_color_error_focus_onlightprimary = "#000000"
export const forms_border_color_error_focus_onlightsecondary = "#000000"
export const forms_border_color_error_focus_onlightbrandneutral = "#000000"
export const forms_border_color_error_focus_ondarkprimary = "#ffffff"
export const forms_border_color_error_focus_ondarksecondary = "#ffffff"
export const forms_border_color_error_focus_ondarkbrandhighlight = "#ffcaaa"
export const forms_border_color_success_tonal_onlightprimary = "#004b1c"
export const forms_border_color_success_tonal_onlightsecondary = "#004b1c"
export const forms_border_color_success_tonal_onlightbrandneutral = "#004b1c"
export const forms_border_color_success_tonal_ondarkprimary = "#a4e6bd"
export const forms_border_color_success_tonal_ondarksecondary = "#a4e6bd"
export const forms_border_color_success_tonal_ondarkbrandhighlight = "#a4e6bd"
export const forms_border_color_success_focus_onlightprimary = "#000000"
export const forms_border_color_success_focus_onlightsecondary = "#000000"
export const forms_border_color_success_focus_onlightbrandneutral = "#000000"
export const forms_border_color_success_focus_ondarkprimary = "#ffffff"
export const forms_border_color_success_focus_ondarksecondary = "#ffffff"
export const forms_border_color_success_focus_ondarkbrandhighlight = "#a4e6bd"
export const forms_element_color_onerror_onlightprimary = "#000000"
export const forms_element_color_onerror_onlightsecondary = "#000000"
export const forms_element_color_onerror_onlightbrandneutral = "#000000"
export const forms_element_color_onerror_ondarkprimary = "#ffffff"
export const forms_element_color_onerror_ondarksecondary = "#ffffff"
export const forms_element_color_onerror_ondarkbrandhighlight = "#000000"
export const forms_element_color_onsuccess_onlightprimary = "#000000"
export const forms_element_color_onsuccess_onlightsecondary = "#000000"
export const forms_element_color_onsuccess_onlightbrandneutral = "#000000"
export const forms_element_color_onsuccess_ondarkprimary = "#ffffff"
export const forms_element_color_onsuccess_ondarksecondary = "#ffffff"
export const forms_element_color_onsuccess_ondarkbrandhighlight = "#000000"
export const forms_container_background_filled_readonly_onlightprimary = "transparent"
export const forms_container_background_filled_readonly_onlightsecondary = "transparent"
export const forms_container_background_filled_readonly_onlightbrandneutral = "transparent"
export const forms_container_background_filled_readonly_ondarkprimary = "#dddad4"
export const forms_container_background_filled_readonly_ondarksecondary = "#dddad4"
export const forms_container_background_filled_readonly_ondarkbrandhighlight = "#000000"
export const forms_highlight_color_overflow_onlightprimary = "#000000"
export const forms_highlight_color_overflow_onlightsecondary = "#000000"
export const forms_highlight_color_overflow_onlightbrandneutral = "#000000"
export const forms_highlight_color_overflow_ondarkprimary = "#ffffff"
export const forms_highlight_color_overflow_ondarksecondary = "#ffffff"
export const forms_highlight_color_overflow_ondarkbrandhighlight = "#000000"
export const forms_text_color_overflow_onlightprimary = "#ffffff"
export const forms_text_color_overflow_onlightsecondary = "#ffffff"
export const forms_text_color_overflow_onlightbrandneutral = "#ffffff"
export const forms_text_color_overflow_ondarkprimary = "#000000"
export const forms_text_color_overflow_ondarksecondary = "#000000"
export const forms_text_color_overflow_ondarkbrandhighlight = "#ffffff"
export const knobs_shadow = "0px 1px 10px 0px rgba(0, 0, 0, 0.24), 0px 2px 4px 0px rgba(0, 0, 0, 0.32)"
export const loader_overlay_background_color_onlightprimary = "rgba(255, 255, 255, 0.9)"
export const loader_overlay_background_color_onlightsecondary = "rgba(248, 247, 245, 0.9)"
export const loader_overlay_background_color_onlightbrandneutral = "rgba(248, 243, 233, 0.9)"
export const loader_overlay_background_color_ondarkprimary = "rgba(0, 0, 0, 0.8)"
export const loader_overlay_background_color_ondarksecondary = "rgba(29, 28, 28, 0.8)"
export const loader_overlay_background_color_ondarkbrandhighlight = "#e10014"
export const modal_closebutton_background_color_unscrolled_onlightprimary = "#ffffff"
export const modal_closebutton_background_color_unscrolled_ondarksecondary = "#1d1c1c"
export const modal_closebutton_background_color_scrolled_onlightprimary = "#ffffff"
export const modal_closebutton_background_color_scrolled_ondarksecondary = "#333332"
export const modal_overlay_color_light = "rgba(0, 0, 0, .80)"
export const modal_overlay_color_dark = "rgba(0, 0, 0, .80)"
export const notification_information_button_label_color_primary_onlightprimary = "#aad8f9"
export const notification_information_button_label_color_primary_onlightsecondary = "#aad8f9"
export const notification_information_button_label_color_primary_onlightbrandneutral = "#aad8f9"
export const notification_information_button_label_color_primary_ondarkprimary = "#003e6c"
export const notification_information_button_label_color_primary_ondarksecondary = "#003e6c"
export const notification_information_button_label_color_primary_ondarkbrandhighlight = "#aad8f9"
export const notification_information_button_background_color_primary_onlightprimary = "#003e6c"
export const notification_information_button_background_color_primary_onlightsecondary = "#003e6c"
export const notification_information_button_background_color_primary_onlightbrandneutral = "#003e6c"
export const notification_information_button_background_color_primary_ondarkprimary = "#aad8f9"
export const notification_information_button_background_color_primary_ondarksecondary = "#aad8f9"
export const notification_information_button_background_color_primary_ondarkbrandhighlight = "#003e6c"
export const notification_success_button_label_color_primary_onlightprimary = "#a4e6bd"
export const notification_success_button_label_color_primary_onlightsecondary = "#a4e6bd"
export const notification_success_button_label_color_primary_onlightbrandneutral = "#a4e6bd"
export const notification_success_button_label_color_primary_ondarkprimary = "#004b1c"
export const notification_success_button_label_color_primary_ondarksecondary = "#004b1c"
export const notification_success_button_label_color_primary_ondarkbrandhighlight = "#a4e6bd"
export const notification_success_button_background_color_primary_onlightprimary = "#004b1c"
export const notification_success_button_background_color_primary_onlightsecondary = "#004b1c"
export const notification_success_button_background_color_primary_onlightbrandneutral = "#004b1c"
export const notification_success_button_background_color_primary_ondarkprimary = "#a4e6bd"
export const notification_success_button_background_color_primary_ondarksecondary = "#a4e6bd"
export const notification_success_button_background_color_primary_ondarkbrandhighlight = "#004b1c"
export const notification_warning_button_label_color_primary_onlightprimary = "#ffe797"
export const notification_warning_button_label_color_primary_onlightsecondary = "#ffe797"
export const notification_warning_button_label_color_primary_onlightbrandneutral = "#ffe797"
export const notification_warning_button_label_color_primary_ondarkprimary = "#685106"
export const notification_warning_button_label_color_primary_ondarksecondary = "#685106"
export const notification_warning_button_label_color_primary_ondarkbrandhighlight = "#ffe797"
export const notification_warning_button_background_color_primary_onlightprimary = "#685106"
export const notification_warning_button_background_color_primary_onlightsecondary = "#685106"
export const notification_warning_button_background_color_primary_onlightbrandneutral = "#685106"
export const notification_warning_button_background_color_primary_ondarkprimary = "#fff1c2"
export const notification_warning_button_background_color_primary_ondarksecondary = "#fff1c2"
export const notification_warning_button_background_color_primary_ondarkbrandhighlight = "#685106"
export const notification_error_button_label_color_primary_onlightprimary = "#ffcaaa"
export const notification_error_button_label_color_primary_onlightsecondary = "#ffcaaa"
export const notification_error_button_label_color_primary_onlightbrandneutral = "#ffcaaa"
export const notification_error_button_label_color_primary_ondarkprimary = "#732706"
export const notification_error_button_label_color_primary_ondarksecondary = "#732706"
export const notification_error_button_label_color_primary_ondarkbrandhighlight = "#ffcaaa"
export const notification_error_button_background_color_primary_onlightprimary = "#732706"
export const notification_error_button_background_color_primary_onlightsecondary = "#732706"
export const notification_error_button_background_color_primary_onlightbrandneutral = "#732706"
export const notification_error_button_background_color_primary_ondarkprimary = "#ffcaaa"
export const notification_error_button_background_color_primary_ondarksecondary = "#ffcaaa"
export const notification_error_button_background_color_primary_ondarkbrandhighlight = "#732706"
export const notification_interactive_focusring_color_onlightprimary = "#000000"
export const notification_interactive_focusring_color_onlightsecondary = "#000000"
export const notification_interactive_focusring_color_onlightbrandneutral = "#000000"
export const notification_interactive_focusring_color_ondarkprimary = "#ffffff"
export const notification_interactive_focusring_color_ondarksecondary = "#ffffff"
export const notification_interactive_focusring_color_ondarkbrandhighlight = "#000000"
export const pagination_pageitem_background_color_hover_onlightprimary = "rgba(170, 168, 163, .12)"
export const pagination_pageitem_background_color_hover_onlightsecondary = "rgba(170, 168, 163, .12)"
export const pagination_pageitem_background_color_hover_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const pagination_pageitem_background_color_hover_ondarkprimary = "rgba(221, 218, 212, .13)"
export const pagination_pageitem_background_color_hover_ondarksecondary = "rgba(221, 218, 212, .13)"
export const pagination_pageitem_background_color_hover_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const scrollable_thumb_color_hover_onlightprimary = "rgba(0, 0, 0, .65)"
export const scrollable_thumb_color_hover_onlightsecondary = "rgba(0, 0, 0, .65)"
export const scrollable_thumb_color_hover_onlightbrandneutral = "rgba(0, 0, 0, .65)"
export const scrollable_thumb_color_hover_ondarkprimary = "rgba(255, 255, 255, .65)"
export const scrollable_thumb_color_hover_ondarksecondary = "rgba(255, 255, 255, .65)"
export const scrollable_thumb_color_hover_ondarkbrandhighlight = "rgba(255, 255, 255, 1)"
export const scrollable_thumb_color_onlightprimary = "rgba(0, 0, 0, .44)"
export const scrollable_thumb_color_onlightsecondary = "rgba(0, 0, 0, .44)"
export const scrollable_thumb_color_onlightbrandneutral = "rgba(0, 0, 0, .44)"
export const scrollable_thumb_color_ondarkprimary = "rgba(255, 255, 255, .44)"
export const scrollable_thumb_color_ondarksecondary = "rgba(255, 255, 255, .44)"
export const scrollable_thumb_color_ondarkbrandhighlight = "rgba(255, 255, 255, .80)"
export const scrollable_thumb_border_color_onlightprimary = "rgba(255, 255, 255, .65)"
export const scrollable_thumb_border_color_onlightsecondary = "rgba(248, 247, 245, .85)"
export const scrollable_thumb_border_color_onlightbrandneutral = "rgba(248, 243, 233, .85)"
export const scrollable_thumb_border_color_ondarkprimary = "rgba(0, 0, 0, .65)"
export const scrollable_thumb_border_color_ondarksecondary = "rgba(29, 28, 28, .65)"
export const scrollable_thumb_border_color_ondarkbrandhighlight = "rgba(255, 0, 20, 1)"
export const table_background_color_striped_onlightprimary = "rgba(170, 168, 163, .12)"
export const table_background_color_striped_onlightsecondary = "rgba(170, 168, 163, .12)"
export const table_background_color_striped_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const table_background_color_striped_ondarkprimary = "rgba(221, 218, 212, .13)"
export const table_background_color_striped_ondarksecondary = "rgba(221, 218, 212, .13)"
export const table_background_color_striped_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const tabs_label_color_highlight_selected_onlightprimary = "#e10014"
export const tabs_label_color_highlight_selected_onlightsecondary = "#e10014"
export const tabs_label_color_highlight_selected_onlightbrandneutral = "#e10014"
export const tabs_indicator_color_highlight_selected_onlightprimary = "#e10014"
export const tabs_indicator_color_highlight_selected_onlightsecondary = "#e10014"
export const tabs_indicator_color_highlight_selected_onlightbrandneutral = "#e10014"
export const textlinkicon_background_color_hover_onlightprimary = "rgba(170, 168, 163, .12)"
export const textlinkicon_background_color_hover_onlightsecondary = "rgba(170, 168, 163, .12)"
export const textlinkicon_background_color_hover_onlightbrandneutral = "rgba(170, 168, 163, .12)"
export const textlinkicon_background_color_hover_ondarkprimary = "rgba(221, 218, 212, .13)"
export const textlinkicon_background_color_hover_ondarksecondary = "rgba(221, 218, 212, .13)"
export const textlinkicon_background_color_hover_ondarkbrandhighlight = "rgba(0, 0, 0, .05)"
export const tiles_standard_border_radius = "0.75rem"
export const tiles_hero_border_radius = "1.5rem"
export const tiles_shadow_subtle_lightbackground_base_onlightprimary = "0px 2px 20px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_base_onlightsecondary = "0px 2px 20px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_base_onlightbrandneutral = "0px 2px 20px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_active_onlightprimary = "0px 1px 15px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_subtle_lightbackground_active_onlightsecondary = "0px 1px 15px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_subtle_lightbackground_active_onlightbrandneutral = "0px 1px 15px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_subtle_lightbackground_hover_onlightprimary = "0px 3px 25px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_hover_onlightsecondary = "0px 3px 25px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_hover_onlightbrandneutral = "0px 3px 25px 1px rgba(0, 0, 0, 0.02)"
export const tiles_shadow_subtle_lightbackground_hoveractive_onlightprimary = "0px 2px 19px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_subtle_lightbackground_hoveractive_onlightsecondary = "0px 2px 19px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_subtle_lightbackground_hoveractive_onlightbrandneutral = "0px 2px 19px 1px rgba(0, 0, 0, 0.04)"
export const tiles_shadow_moderate_lightbackground_base_onlightprimary = "0px 2px 20px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_base_onlightsecondary = "0px 2px 20px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_base_onlightbrandneutral = "0px 2px 20px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_active_onlightprimary = "0px 1px 15px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_lightbackground_active_onlightsecondary = "0px 1px 15px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_lightbackground_active_onlightbrandneutral = "0px 1px 15px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_lightbackground_hover_onlightprimary = "0px 3px 25px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_hover_onlightsecondary = "0px 3px 25px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_hover_onlightbrandneutral = "0px 3px 25px 0px rgba(0, 0, 0, 0.06)"
export const tiles_shadow_moderate_lightbackground_hoveractive_onlightprimary = "0px 2px 19px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_lightbackground_hoveractive_onlightsecondary = "0px 2px 19px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_lightbackground_hoveractive_onlightbrandneutral = "0px 2px 19px 0px rgba(0, 0, 0, 0.08)"
export const tiles_shadow_moderate_darkbackground_base_onlightprimary = "0px 2px 20px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_base_onlightsecondary = "0px 2px 20px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_base_onlightbrandneutral = "0px 2px 20px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_active_onlightprimary = "0px 1px 15px 0px rgba(0, 0, 0, 0.18)"
export const tiles_shadow_moderate_darkbackground_active_onlightsecondary = "0px 1px 15px 0px rgba(0, 0, 0, 0.18)"
export const tiles_shadow_moderate_darkbackground_active_onlightbrandneutral = "0px 1px 15px 0px rgba(0, 0, 0, 0.18)"
export const tiles_shadow_moderate_darkbackground_hover_onlightprimary = "0px 3px 25px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_hover_onlightsecondary = "0px 3px 25px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_hover_onlightbrandneutral = "0px 3px 25px 0px rgba(0, 0, 0, 0.16)"
export const tiles_shadow_moderate_darkbackground_hoveractive_onlightprimary = "0px 2px 19px 0px rgba(0, 0, 0, 0.18)"
export const tiles_shadow_moderate_darkbackground_hoveractive_onlightbrandneutral = "0px 2px 19px 0px rgba(0, 0, 0, 0.18)"
export const tiles_shadow_moderate_darkbackground_hoveractive_onlightsecondary = "0px 2px 19px 0px rgba(0, 0, 0, 0.18)"
export const toggle_track_background_color_onlightprimary = "rgba(51, 51, 50, 0.5)"
export const toggle_track_background_color_onlightsecondary = "rgba(51, 51, 50, 0.5)"
export const toggle_track_background_color_onlightbrandneutral = "rgba(51, 51, 50, 0.5)"
export const toggle_track_background_color_ondarkprimary = "rgba(51, 51, 50, 0.5)"
export const toggle_track_background_color_ondarksecondary = "rgba(51, 51, 50, 0.5)"
export const toggle_track_background_color_ondarkbrandhighlight = "rgba(51, 51, 50, 0.4)"
export const toggle_track_background_color_selected_onlightprimary = "#00b845"
export const toggle_track_background_color_selected_onlightsecondary = "#00b845"
export const toggle_track_background_color_selected_onlightbrandneutral = "#00b845"
export const toggle_track_background_color_selected_ondarkprimary = "#00b845"
export const toggle_track_background_color_selected_ondarksecondary = "#00b845"
export const toggle_track_background_color_selected_ondarkbrandhighlight = "#00b845"
export const toggle_track_border_color_onlightprimary = "rgba(0, 0, 0, 0.2)"
export const toggle_track_border_color_onlightsecondary = "rgba(0, 0, 0, 0.2)"
export const toggle_track_border_color_onlightbrandneutral = "rgba(0, 0, 0, 0.2)"
export const toggle_track_border_color_ondarkprimary = "rgba(255, 255, 255, 0.35)"
export const toggle_track_border_color_ondarksecondary = "rgba(255, 255, 255, 0.35)"
export const toggle_track_border_color_ondarkbrandhighlight = "rgba(255, 255, 255, 0.78)"
export const toggle_track_border_color_selected_onlightprimary = "rgba(0, 0, 0, 0.25)"
export const toggle_track_border_color_selected_onlightsecondary = "rgba(0, 0, 0, 0.25)"
export const toggle_track_border_color_selected_onlightbrandneutral = "rgba(0, 0, 0, 0.25)"
export const toggle_track_border_color_selected_ondarkprimary = "rgba(255, 255, 255, 0.6)"
export const toggle_track_border_color_selected_ondarksecondary = "rgba(255, 255, 255, 0.6)"
export const toggle_track_border_color_selected_ondarkbrandhighlight = "rgba(255, 255, 255, 0.6)"
export const tooltip_overlay_color_light = "rgba(0, 0, 0, 0.4)"
export const tooltip_overlay_color_dark = "rgba(0, 0, 0, 0.6)"
export const interactive_focusring_style = "dashed"
export const interactive_focusring_offset = "0.125rem"
export const interactive_focusring_width = "0.0625rem"
export const interactive_focusring_color_onlightprimary = "#000000"
export const interactive_focusring_color_onlightsecondary = "#000000"
export const interactive_focusring_color_onlightbrandneutral = "#000000"
export const interactive_focusring_color_ondarkprimary = "#ffffff"
export const interactive_focusring_color_ondarksecondary = "#ffffff"
export const interactive_focusring_color_ondarkbrandhighlight = "#ffffff"
export const interactive_opacity_active_onlightprimary = "60%"
export const interactive_opacity_active_onlightsecondary = "60%"
export const interactive_opacity_active_onlightbrandneutral = "60%"
export const interactive_opacity_active_ondarkprimary = "60%"
export const interactive_opacity_active_ondarksecondary = "60%"
export const interactive_opacity_active_ondarkbrandhighlight = "100%"
export const interactive_opacity_disabled_onlightprimary = "17%"
export const interactive_opacity_disabled_onlightsecondary = "17%"
export const interactive_opacity_disabled_onlightbrandneutral = "17%"
export const interactive_opacity_disabled_ondarkprimary = "17%"
export const interactive_opacity_disabled_ondarksecondary = "17%"
export const interactive_opacity_disabled_ondarkbrandhighlight = "40%"
export const shadow_elevation_middle_lightbackground_base_onlightprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_base_onlightsecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_base_onlightbrandneutral = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_base_ondarkprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_base_ondarksecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_base_ondarkbrandhighlight = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_onlightprimary = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_onlightsecondary = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_onlightbrandneutral = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_ondarkprimary = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_ondarksecondary = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_active_ondarkbrandhighlight = "0px 1px 6px 0px rgba(0, 0, 0, 0.08), 0px 1px 11px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_onlightprimary = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_onlightsecondary = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_onlightbrandneutral = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_ondarkprimary = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_ondarksecondary = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hover_ondarkbrandhighlight = "0px 1px 10px 0px rgba(0, 0, 0, 0.08), 0px 3px 18px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_onlightprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_onlightsecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_onlightbrandneutral = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_ondarkprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_ondarksecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_lightbackground_hoveractive_ondarkbrandhighlight = "0px 1px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 14px 0px rgba(0, 0, 0, 0.06)"
export const shadow_elevation_middle_darkbackground_base_onlightprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_base_onlightsecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_base_onlightbrandneutral = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_base_ondarkprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_base_ondarksecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_base_ondarkbrandhighlight = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_onlightprimary = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_onlightsecondary = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_onlightbrandneutral = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_ondarkprimary = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_ondarksecondary = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_active_ondarkbrandhighlight = "0px 1px 6px 0px rgba(0, 0, 0, 0.16), 0px 1px 11px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_onlightprimary = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_onlightsecondary = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_onlightbrandneutral = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_ondarkprimary = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_ondarksecondary = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hover_ondarkbrandhighlight = "0px 1px 10px 0px rgba(0, 0, 0, 0.16), 0px 3px 18px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_onlightprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_onlightsecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_onlightbrandneutral = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_ondarkprimary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_ondarksecondary = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_middle_darkbackground_hoveractive_ondarkbrandhighlight = "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 2px 14px 0px rgba(0, 0, 0, 0.15)"
export const shadow_elevation_high_lightbackground_base_onlightprimary = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_base_onlightsecondary = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_base_onlightbrandneutral = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_base_ondarkprimary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_base_ondarksecondary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_base_ondarkbrandhighlight = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_active_onlightprimary = "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_active_onlightsecondary = "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_active_onlightbrandneutral = "0px 1px 15px 0px rgba(0, 0, 0, 0.08), 0px 2px 15px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_active_ondarkprimary = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_active_ondarksecondary = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_active_ondarkbrandhighlight = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hover_onlightprimary = "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hover_onlightsecondary = "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hover_onlightbrandneutral = "0px 1px 25px 0px rgba(0, 0, 0, 0.08), 0px 4px 25px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hover_ondarkprimary = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hover_ondarksecondary = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hover_ondarkbrandhighlight = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hoveractive_onlightprimary = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hoveractive_onlightsecondary = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hoveractive_onlightbrandneutral = "0px 1px 20px 0px rgba(0, 0, 0, 0.08), 0px 3px 20px 0px rgba(0, 0, 0, 0.07)"
export const shadow_elevation_high_lightbackground_hoveractive_ondarkprimary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hoveractive_ondarksecondary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_lightbackground_hoveractive_ondarkbrandhighlight = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_base_onlightprimary = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_base_onlightsecondary = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_base_onlightbrandneutral = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_base_ondarkprimary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_base_ondarksecondary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_base_ondarkbrandhighlight = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_active_onlightprimary = "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_active_onlightsecondary = "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_active_onlightbrandneutral = "0px 1px 15px 0px rgba(0, 0, 0, 0.16), 0px 2px 15px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_active_ondarkprimary = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_active_ondarksecondary = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_active_ondarkbrandhighlight = "0px 2px 6px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hover_onlightprimary = "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hover_onlightsecondary = "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hover_onlightbrandneutral = "0px 1px 25px 0px rgba(0, 0, 0, 0.16), 0px 4px 25px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hover_ondarkprimary = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hover_ondarksecondary = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hover_ondarkbrandhighlight = "0px 4px 10px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hoveractive_onlightprimary = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hoveractive_onlightsecondary = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hoveractive_onlightbrandneutral = "0px 1px 20px 0px rgba(0, 0, 0, 0.16), 0px 3px 20px 0px rgba(0, 0, 0, 0.18)"
export const shadow_elevation_high_darkbackground_hoveractive_ondarkprimary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hoveractive_ondarksecondary = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const shadow_elevation_high_darkbackground_hoveractive_ondarkbrandhighlight = "0px 3px 8px 0px rgba(0, 0, 0, 0.24)"
export const space_halfx = "0.125rem"
export const space_1x = "0.25rem"
export const space_2x = "0.5rem"
export const space_3x = "0.75rem"
export const space_4x = "1rem"
export const space_6x = "1.5rem"
export const space_8x = "2rem"
export const space_12x = "3rem"
export const space_16x = "4rem"
export const space_24x = "6rem"
export const space_32x = "8rem"
export const size_border_radius_0 = "0"
export const size_border_radius_50 = "0.125rem"
export const size_border_radius_100 = "0.25rem"
export const size_border_radius_200 = "0.5rem"
export const size_border_radius_250 = "0.625rem"
export const size_border_radius_300 = "0.75rem"
export const size_border_radius_400 = "1rem"
export const size_border_radius_600 = "1.5rem"
export const size_border_radius_800 = "2rem"
export const size_border_radius_max = "624.9375rem"
export const size_border_width = "0.0625rem"
export const typography_body_large_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_body_large_fontsize = "1rem"
export const typography_body_large_lineheight = "1.25rem"
export const typography_body_large_fontweight_bold = "700"
export const typography_body_large_fontweight_regular = "400"
export const typography_body_large_letterspacing_bold = "0.03125rem"
export const typography_body_large_letterspacing_regular = "0.03125rem"
export const typography_body_medium_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_body_medium_fontsize = "0.875rem"
export const typography_body_medium_lineheight = "1.125rem"
export const typography_body_medium_fontweight_bold = "700"
export const typography_body_medium_fontweight_regular = "400"
export const typography_body_medium_letterspacing_bold = "0.03125rem"
export const typography_body_medium_letterspacing_regular = "0.03125rem"
export const typography_body_small_fontfamily = "Verizon-NHG-eTX, Helvetica, Arial, sans-serif"
export const typography_body_small_fontsize = "0.75rem"
export const typography_body_small_lineheight = "1rem"
export const typography_body_small_fontweight_bold = "700"
export const typography_body_small_fontweight_regular = "400"
export const typography_body_small_letterspacing_bold = "normal"
export const typography_body_small_letterspacing_regular = "normal"
export const typography_feature_xlarge_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_feature_xlarge_fontsize = "9rem"
export const typography_feature_xlarge_lineheight = "8.5rem"
export const typography_feature_xlarge_fontweight_bold = "700"
export const typography_feature_xlarge_fontweight_regular = "300"
export const typography_feature_xlarge_letterspacing_bold = "normal"
export const typography_feature_xlarge_letterspacing_regular = "0.015625rem"
export const typography_feature_large_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_feature_large_fontsize = "8rem"
export const typography_feature_large_lineheight = "7.5rem"
export const typography_feature_large_fontweight_bold = "700"
export const typography_feature_large_fontweight_regular = "300"
export const typography_feature_large_letterspacing_bold = "normal"
export const typography_feature_large_letterspacing_regular = "0.015625rem"
export const typography_feature_medium_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_feature_medium_fontsize = "6rem"
export const typography_feature_medium_lineheight = "5.5rem"
export const typography_feature_medium_fontweight_bold = "700"
export const typography_feature_medium_fontweight_regular = "300"
export const typography_feature_medium_letterspacing_bold = "normal"
export const typography_feature_medium_letterspacing_regular = "0.015625rem"
export const typography_feature_small_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_feature_small_fontsize = "5rem"
export const typography_feature_small_lineheight = "4.75rem"
export const typography_feature_small_fontweight_bold = "700"
export const typography_feature_small_fontweight_regular = "300"
export const typography_feature_small_letterspacing_bold = "normal"
export const typography_feature_small_letterspacing_regular = "0.015625rem"
export const typography_fontfamily_edisplay = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_fontfamily_etext = "Verizon-NHG-eTX, Helvetica, Arial, sans-serif"
export const typography_fontweight_bold = "700"
export const typography_fontweight_regular = "400"
export const typography_fontweight_light = "300"
export const typography_letterspacing_wide = "0.03125rem"
export const typography_letterspacing_semiwide = "0.015625rem"
export const typography_letterspacing_normal = "normal"
export const typography_micro_fontfamily = "Verizon-NHG-eTX, Helvetica, Arial, sans-serif"
export const typography_micro_fontsize = "0.6875rem"
export const typography_micro_lineheight = "1rem"
export const typography_micro_fontweight_bold = "700"
export const typography_micro_fontweight_regular = "400"
export const typography_micro_letterspacing_bold = "normal"
export const typography_micro_letterspacing_regular = "normal"
export const typography_title_2xlarge_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_2xlarge_fontsize = "4rem"
export const typography_title_2xlarge_lineheight = "4rem"
export const typography_title_2xlarge_fontweight_bold = "700"
export const typography_title_2xlarge_fontweight_regular = "300"
export const typography_title_2xlarge_letterspacing_bold = "normal"
export const typography_title_2xlarge_letterspacing_regular = "0.015625rem"
export const typography_title_xlarge_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_xlarge_fontsize = "3rem"
export const typography_title_xlarge_lineheight = "3rem"
export const typography_title_xlarge_fontweight_bold = "700"
export const typography_title_xlarge_fontweight_regular = "300"
export const typography_title_xlarge_letterspacing_bold = "normal"
export const typography_title_xlarge_letterspacing_regular = "0.015625rem"
export const typography_title_large_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_large_fontsize = "2.5rem"
export const typography_title_large_lineheight = "2.5rem"
export const typography_title_large_fontweight_bold = "700"
export const typography_title_large_fontweight_regular = "300"
export const typography_title_large_letterspacing_bold = "normal"
export const typography_title_large_letterspacing_regular = "0.015625rem"
export const typography_title_medium_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_medium_fontsize = "2rem"
export const typography_title_medium_lineheight = "2.25rem"
export const typography_title_medium_fontweight_bold = "700"
export const typography_title_medium_fontweight_regular = "400"
export const typography_title_medium_letterspacing_bold = "normal"
export const typography_title_medium_letterspacing_regular = "normal"
export const typography_title_small_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_small_fontsize = "1.5rem"
export const typography_title_small_lineheight = "1.75rem"
export const typography_title_small_fontweight_bold = "700"
export const typography_title_small_fontweight_regular = "400"
export const typography_title_small_letterspacing_bold = "normal"
export const typography_title_small_letterspacing_regular = "normal"
export const typography_title_xsmall_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_xsmall_fontsize = "1.25rem"
export const typography_title_xsmall_lineheight = "1.5rem"
export const typography_title_xsmall_fontweight_bold = "700"
export const typography_title_xsmall_fontweight_regular = "400"
export const typography_title_xsmall_letterspacing_bold = "normal"
export const typography_title_xsmall_letterspacing_regular = "normal"
export const typography_title_2xsmall_fontfamily = "Verizon-NHG-DS, Helvetica, Arial, sans-serif"
export const typography_title_2xsmall_fontsize = "1rem"
export const typography_title_2xsmall_lineheight = "1.25rem"
export const typography_title_2xsmall_fontweight_bold = "700"
export const typography_title_2xsmall_fontweight_regular = "400"
export const typography_title_2xsmall_letterspacing_bold = "normal"
export const typography_title_2xsmall_letterspacing_regular = "normal"
